export default 
{
  ENGLISH: {
    CONSOLTO_WIDGET: {
      LETS_TALK: "Let's talk",
      MORE_INFO: 'more info',
      TALK_TO_ME_NOW: 'Talk to me now',
      FREE: 'FREE!!',
      MINUTES: 'Minutes',
      VIDEO_CALL: 'Video call',
      SCHEDULE_A_MEETING: 'Schedule a meeting',
      SEND_FB_MESSAGE: 'Send FB message',
      SEND_A_WHATSAPP: 'Send a whatsapp',
      PHONE_CALL: 'Call',
      YOUR_MESSAGE_HERE: 'Your message here',
      LEAVE_A_MESSAGE: 'Leave a message',
      SEND: 'Send',
      HOW_CAN_WE_REACH_YOU: 'How can we reach you?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'In Order to get back to you please leave your details',
      NAME: 'Name',
      PHONE: 'Phone',
      EMAIL: 'Email',
      CHAT: 'Chat',
      WEBCALL: 'Webcall',
      VIDEO: 'Video',
      SCHEDULE: 'Schedule',
      WHATSAPP: 'Whatsapp',
      MESSENGER: 'Messenger',
      MESSAGE: 'Message',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Say something',
      START_CHAT: 'Start Chat',
      CONTACT: 'Contact',
      ACTION_SELECTOR_HEADER: 'Welcome!',
      TEXT_CHAT_HEADER: 'Chat',
      WEBCALL_HEADER: 'Web Call',
      WHATSAPP_HEADER: 'Whatsapp',
      FB_MESSENGER_HEADER: 'Messenger',
      SCHEDULE_MEETING_HEADER: 'Schedule Meeting',
      PHONE_CALL_HEADER: 'Phone',
      INFO_COLLECTOR_HEADER: 'Contact Form'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: "I'm not available right now",
      PLEASE_LEAVE_ME_A_MESSAGE: 'please leave me a message',
      MESSAGE_STAR: 'Message*',
      YOUR_MESSAGE_HERE: 'Your message here',
      NAME: 'Name',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      EMAIL: 'Email',
      INVALID_EMAIL: 'Invalid email',
      INVALID_PHONE_NUMBER: 'Invalid phone number',
      OR: 'OR',
      SCHEDULE_A_MEETING: 'Schedule a meeting',
      SEND_FB_MESSAGE: 'Send FB message',
      SEND_A_WHATSAPP: 'Send a whatsapp',
      PHONE: 'Phone',
      PHONE_CALL: 'Call',
      SEND: 'Send',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'What is your name?',
      WHAT_IS_YOUR_EMAIL: 'What is your email?',
      WHAT_IS_YOUR_PHONE: 'What is your phone number? ',
      WHAT_IS_YOUR_QUESTION: 'What is your question? '
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: "Let's schedule a meeting",
      NEXT: 'Next',
      BACK: 'Back',
      ADD_ANOTHER_OPTION: 'Add another option',
      GIVE_ALTERNATIVES: 'Give a few alternatives to make the scheduling flow easier',
      TIME_ZONE: 'Time zone',
      WHAT_IS_YOUR_EMAIL: 'What is your email?',
      ADD_NOTE: 'Add a note...',
      INVALID_EMAIL: 'Invalid email',
      THANKS_FOR_BOOKING: 'Thanks for your booking',
      YOUR_REQUEST_WAS_SENT: 'Your meeting request has been sent and is waiting for approval. ',
      WELL_GET_BACK: 'We’ll get back to you by email.',
      CHOOSE_TIME: 'Choose time',
      ENTER_EMAIL: 'Enter your email',
      OPTIONAL: 'optional',
      WHEN_DO_YOU_WANT_TO_MEET: 'When do you want to meet? ',
      PICK_UP_TO_THREE: 'Pick up to three options for this meeting. Your client will need to approve one alternative',
      SEND_INVITATION: 'Send invitation',
      INVITATION_FAILED: "Ohh... something went wrong... Please check that the meeting times aren't in the past",
      YOUR_NOTES: 'Your notes',
      YOUR_PROPOSED_TIMES: 'Your proposed meeting time',
      RESCHEDULE_MEETING: 'Reschedule meeting',
      CANCEL_MEETING: 'Cancel meeting',
      DECLINE_MEETING: 'Decline',
      SURE_CANCEL: 'Are you sure you want to cancel this appointment?',
      YES_CANCEL: 'Yes, Cancel',
      NEVER_MIND: 'Never mind',
      CANCELLED: 'Cancelled',
      RESCHEDULED: 'Rescheduled',
      DECLINED: 'Declined',
      CONFIRMED: 'Confirmed',
      ADD_TO_CALENDAR: 'Add to calendar',
      REMOVE_FROM_CALENDAR: 'Remove from calendar',
      SUGGEST_NEW_TIME: 'Suggest new time for meeting',
      SET_UPTO_THREE_OPTIONS: 'You can setup up to 3 options. One will be accepted.',
      REQUEST_SENT: 'Your request was sent',
      WAITING_FOR_APPROVAL: 'Waiting for approval.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Schedule another appointment',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SELECT_MEETING_DATE_AND_TIME: 'Select date and time',
      MEETING_DETAILS: 'Meeting Details'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: "Hi, I'm not available right now. ",
      LEAVE_MESSAGE: 'Leave me a message',
      OR: 'or',
      SCHEDULE_A_MEETING: 'Schedule a meeting.',
      TRY_AGAIN: 'Try again',
      CALL_SETTINGS: 'Call Settings',
      CAMERA: 'Camera',
      MICROPHONE: 'Microphone',
      SPEAKERS: 'Speakers',
      CHAT: 'Chat',
      TEST: 'Test',
      VIDEO: 'Video',
      AUDIO: 'Audio Only',
      SHARE_SCREEN: 'Share screen',
      CONNECTING: 'Connecting',
      RINGING: 'Ringing',
      SWITCH_CAMERA: 'Switch camera',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Hangup',
      ON_OFF: 'Off/On',
      PEER_IS_READY_PAYMENT: 'Your peer is ready. Please start payment',
      PAY_NOW: 'Pay now',
      CALL_END: 'Call Ended :)',
      CALL_NOW: 'Call now',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Call Ended',
      SELF_CONNECTION_CLOSED: 'Call Ended',
      CAMERA_ACCESS_PREVENTED: "We couldn't get access to the camera and/or microphone on this device. Please enable them first.",
      CAMERA_ACCESS_DIALOG_OPEN: 'Please approve the camera and microphone in order to start a video call.',
      REJECTED_CALL_MESSAGE: 'Please try again later',
      SELF_CALL_MESSAGE: "We're sorry. \\n You are trying to call yourself.",
      SWITCHING: 'Switching',
      ONLY_YOU_STREAM: 'Only you stream',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'In',
      SECONDS: 'Seconds',
      PEOPLE_RECEIVED_CALLS_TODAY: 'People received calls today',
      SECURED: 'Secured',
      FROM: 'From',
      IS_CALLING_YOU: 'is calling you',
      OVER_A_SECURED_WEBCALL: 'over a secured web call',
      ACCEPT: 'Accept',
      DECLINE: 'Decline',
      CALL_REQUEST: 'You have a call request',
      PAYMENT_REQUEST: 'You have a payment request',
      PAY_NOW: 'Pay now',
      CANCEL: 'Cancel',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  HEBREW: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'מענה אנושי',
      MORE_INFO: 'עוד מידע...',
      TALK_TO_ME_NOW: 'דברו איתי עכשיו',
      FREE: 'חינם!',
      MINUTES: 'דקות',
      VIDEO_CALL: 'שיחת וידאו',
      SCHEDULE_A_MEETING: 'פגישה',
      SEND_FB_MESSAGE: 'פייסבוק',
      SEND_A_WHATSAPP: 'וואטסאפ',
      PHONE_CALL: 'טלפון',
      YOUR_MESSAGE_HERE: 'הודעתך כאן',
      LEAVE_A_MESSAGE: 'השאירו הודעה',
      SEND: 'שליחה',
      HOW_CAN_WE_REACH_YOU: 'איך ניצור עמך קשר?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'על מנת לחזור אליך נצטרך כמה פרטים',
      NAME: 'שם',
      PHONE: 'טלפון',
      EMAIL: 'אימייל',
      CHAT: "צ'ט",
      WEBCALL: "וידאוצ'ט",
      VIDEO: 'וידאו',
      SCHEDULE: 'פגישה',
      WHATSAPP: 'וואטסאפ',
      MESSENGER: 'פייסבוק',
      MESSAGE: 'הודעה',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'כיתבו משהו',
      START_CHAT: 'התחילו לכתוב',
      CONTACT: 'יצירת קשר',
      ACTION_SELECTOR_HEADER: 'ברוכים הבאים',
      TEXT_CHAT_HEADER: "צ'ט",
      WEBCALL_HEADER: "וידאוצ'ט",
      WHATSAPP_HEADER: 'וואטסאפ',
      FB_MESSENGER_HEADER: 'פייסבוק',
      SCHEDULE_MEETING_HEADER: 'פגישה',
      PHONE_CALL_HEADER: 'טלפון',
      INFO_COLLECTOR_HEADER: 'הודעה'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'אינני פנוי/ה כרגע',
      PLEASE_LEAVE_ME_A_MESSAGE: 'השאירו הודעה',
      MESSAGE_STAR: 'הודעה*',
      YOUR_MESSAGE_HERE: 'הודעתך כאן',
      NAME: 'שם',
      FIRST_NAME: 'שם פרטי',
      LAST_NAME: 'שם משפחה',
      EMAIL: 'מייל',
      INVALID_EMAIL: 'כתובת מייל לא תקינה',
      INVALID_PHONE_NUMBER: 'טלפון לא תקין',
      OR: 'או',
      SCHEDULE_A_MEETING: 'קיבעו פגישה',
      SEND_FB_MESSAGE: 'הודעת פייסבוק',
      SEND_A_WHATSAPP: 'הודעת וואטסאפ',
      PHONE: 'טלפון',
      PHONE_CALL: 'שיחה',
      SEND: 'שליחה',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'מה שמך?',
      WHAT_IS_YOUR_EMAIL: 'כתובת אימייל?',
      WHAT_IS_YOUR_PHONE: 'מספר טלפון? ',
      WHAT_IS_YOUR_QUESTION: 'איך אפשר לעזור? '
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'נקבע פגישה?',
      NEXT: 'הבא',
      BACK: 'קודם',
      ADD_ANOTHER_OPTION: 'הוסיפו עוד אלטרנטיבה',
      GIVE_ALTERNATIVES: 'עוד זמנים לפגישה מקלים על תיאום הפגישה',
      TIME_ZONE: 'אזור זמן',
      WHAT_IS_YOUR_EMAIL: 'מה האימייל שלך?',
      ADD_NOTE: 'הוסיפו הודעה',
      INVALID_EMAIL: 'כתובת מייל לא תקינה',
      THANKS_FOR_BOOKING: 'תודה על קביעת הפגישה',
      YOUR_REQUEST_WAS_SENT: 'הבקשה נשלחה וממתינה לאישור',
      WELL_GET_BACK: 'נחזור אליך במייל.',
      CHOOSE_TIME: 'בחירת זמן',
      ENTER_EMAIL: 'כתובת אימייל כאן',
      OPTIONAL: 'לא חובה',
      WHEN_DO_YOU_WANT_TO_MEET: 'מתי נקבע את הפגישה?',
      PICK_UP_TO_THREE: 'ניתן להציע עד 3 מועדים. הלקוח יאשר אחד מהם. ',
      SEND_INVITATION: 'שליחת זימון',
      INVITATION_FAILED: 'אוי... משהו לא הלך כמו שצריך. אנא בידקו שזמני הפגישה אינם בעבר',
      YOUR_NOTES: 'הודעה אישית',
      YOUR_PROPOSED_TIMES: 'זמני הפגישה שהצעת',
      RESCHEDULE_MEETING: 'קביעת זמן מחדש',
      CANCEL_MEETING: 'ביטול פגישה',
      DECLINE_MEETING: 'דחיית הזמנה',
      SURE_CANCEL: 'בטוח שרוצים לבטל את הפגישה? ',
      YES_CANCEL: 'כן, לבטל',
      NEVER_MIND: 'לא משנה',
      CANCELLED: 'בוטל',
      RESCHEDULED: 'נקבע זמן אחר',
      DECLINED: 'נדחה',
      CONFIRMED: 'מאושר',
      ADD_TO_CALENDAR: 'הוסף ליומן',
      REMOVE_FROM_CALENDAR: 'הסר מהיומן',
      SUGGEST_NEW_TIME: 'הצע זמן אחר',
      SET_UPTO_THREE_OPTIONS: 'ניתן להציע עד 3 מועדים. מועד אחד יתקבל.',
      REQUEST_SENT: 'בקשתך נשלחה',
      WAITING_FOR_APPROVAL: 'מחכים לאישור.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'לקביעת פגישה נוספת',
      EDIT: 'עריכה',
      DELETE: 'מחיקה',
      SELECT_MEETING_DATE_AND_TIME: 'בחרו יום ושעה',
      MEETING_DETAILS: 'פרטי פגישה'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'היי, אני לא זמינ/ה כרגע ',
      LEAVE_MESSAGE: 'השאירו הודעה',
      OR: 'או ',
      SCHEDULE_A_MEETING: 'קבעו עימי פגישה',
      TRY_AGAIN: 'נסו שוב',
      CALL_SETTINGS: 'תפריט שיחה',
      CAMERA: 'מצלמה',
      MICROPHONE: 'מיקרופון',
      SPEAKERS: 'שמע (רמקולים)',
      CHAT: "צ'ט",
      TEST: 'בדיקה',
      VIDEO: 'וידאו',
      AUDIO: 'שמע בלבד',
      SHARE_SCREEN: 'שיתוף מסך',
      CONNECTING: 'מתחבר',
      RINGING: 'מצלצל',
      SWITCH_CAMERA: 'החלפת מצלמה',
      BACKGROUND_EFFECTS: 'שינוי רקע',
      BLUR: 'טשטוש רקע',
      CLOSE: 'חזרה',
      SET_BACKGROUND: 'שמירה',
      HANGUP: 'ניתוק',
      ON_OFF: 'הדלקה/כיבוי',
      PEER_IS_READY_PAYMENT: 'השיחה התקבלה. ניתן להמשיך בתשלום',
      PAY_NOW: 'תשלום',
      CALL_END: 'שיחה הסתיימה',
      CALL_NOW: 'טלפון',
      PEER_CONNECTION_CLOSED_MESSAGE: 'שיחה הסתיימה',
      SELF_CONNECTION_CLOSED: 'שיחה הסתיימה',
      CAMERA_ACCESS_PREVENTED: 'לא ניתנה גישה למצלמה או מיקרופון. נא לאפשר גישה על מנת להתקדם',
      CAMERA_ACCESS_DIALOG_OPEN: 'נא לאשר גישה למיקרופון ולמצלמה על מנת לבצע שיחת וידאו',
      REJECTED_CALL_MESSAGE: 'אנא נסו שוב מאוחר יותר',
      SELF_CALL_MESSAGE: 'לא ניתן להתקשר לעצמך',
      SWITCHING: 'מחליפים',
      ONLY_YOU_STREAM: 'שידור בלבד',
      DIRECT_CALL: 'לביצוע שיחה, פתחו את הקישור בדפדפן הרגיל',
      OPEN_MEETING_IN_CONSOLTO: 'האם לפתוח את הפגישה Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'אמשיך כאן',
      INVALID_MEETING_LINK: 'קישור פגישה שגוי',
      SESSION_UNAVAILABLE: 'הפגישה נסתיימה',
      SEND_MSG_OR_ARRANGE_MEETING: 'קבעו עימי פגישה או שלחו הודעה',
      SCHEDULE_NEW_MEETING: 'לקביעת פגישה חדשה',
      WHEN_READY_ENTER_MEETING: 'כאשר מוכנים, הכנסו לפגישה',
      MEETING_STARTS_IN: 'הפגישה מתחילה תוך: ',
      MEETING_TIME_ARRIVED: 'הפגישה התחילה, ניתן להכנס',
      MEETING_OVER: 'הפגישה נסתיימה',
      MEETING_NOT_STARTED: 'פגישה זו לא התחילה עדיין',
      MEETING_STARTED: 'הפגישה התחילה',
      ANOTHER_MEETING: 'בפגישה אחרת. כבר יצטרף',
      WILL_JOIN_SOON: 'יצטרף בקרוב',
      HAS_JOINED: 'הצטרף כבר',
      YOU_LEFT_MEETTING: 'עזבת את הפגישה',
      READY: 'מוכנים?',
      MEETING_ROOM_FULL: 'חדר הפגישה מלא',
      RECONNECT: 'הצטרפות מחדש?',
      ENTER_MEETING: 'הכנסו לפגישה',
      ARE_YOU_HOST: 'האם אתם היוזמים של הפגישה?',
      JOIN_HERE: 'הצטרפו כאן',
      PARTICIPANTS: 'אורחים',
      ENABLE_CAMERA: 'אפשרו גישה למצלמה',
      ENABLE_MICROPHONE: 'אפשרו גישה למצלמה ומיקרופון',
      ENABLE_MICROPHONE_CAMERA: 'מתן גישה למיקרופון ולמצלמה',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'אפשרו גישה למיקרופון. תמיד ניתן להסיר מאוחר יותר. ',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'אפשרו גישה למצלמה. תמיד ניתן להסיר מאוחר יותר. ',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'אפשרו גישה למיקרופון ולמצלמה. תמיד ניתן להסיר מאוחר יותר. ',
      CAMERA_BLOCKED: 'המצלמה חסומה',
      MICROPHONE_BLOCKED: 'המיקרופון חסום',
      CAMERA_MICROPHONE_BLOCKED: 'מיקרופון ומצלמה חסומים',
      NEED_HELP: 'צריכים עזרה?',
      CLICK_TO_ENABLE: 'לשינוי הגדרות',
      MEETING_TITLE: 'נושא הפגישה',
      EXIT_FULL_SCREEN: 'יציאה ממסך מלא',
      FULL_SCREEN_STREAM: 'מסך מלא למשתתף',
      FULL_SCREEN_WINDOW: 'מסך מלא',
      MINIMIZE_STREAM: 'הקטנת משתתף',
      MAXIMIZE_STREAM: 'הגדלת משתתף',
      MINIMIZE_MEETING: 'הקטנת שיחה',
      MAXIMIZE_MEETING: 'הגדלת שיחה',
      GALLERY_VIEW_MODE: 'גלריה: חלונות יוצגו זה לצד זה',
      CALL_BEING_RECORDED: 'שיחה זו מוקלטת'
    },
    ACTIVE_AGENT: {
      IN: 'בעוד',
      SECONDS: 'שניות',
      PEOPLE_RECEIVED_CALLS_TODAY: 'אנשים קיבלו שיחות היום',
      SECURED: 'מאובטחת',
      FROM: 'מחברת',
      IS_CALLING_YOU: 'מתקשר אליך',
      OVER_A_SECURED_WEBCALL: 'השיחה המאובטחת מתבצעת כאן, דרך האתר!',
      ACCEPT: 'אישור',
      DECLINE: 'דחה',
      CALL_REQUEST: 'שיחה ממתינה',
      PAYMENT_REQUEST: 'מחכה בקשת תשלום',
      PAY_NOW: 'שלמו כעת',
      CANCEL: 'ביטול',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  HUNGARIAN: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Beszélgessünk',
      MORE_INFO: 'több információ',
      TALK_TO_ME_NOW: 'Beszélj hozzám',
      FREE: 'INGYENES!!',
      MINUTES: 'Perc',
      VIDEO_CALL: 'Videohívás',
      SCHEDULE_A_MEETING: 'Találkozó tervezése',
      SEND_FB_MESSAGE: 'FB üzenet küldése',
      SEND_A_WHATSAPP: 'Whatsapp üzenet küldése',
      PHONE_CALL: 'Hívás',
      YOUR_MESSAGE_HERE: 'Üzeneted ',
      LEAVE_A_MESSAGE: 'Hagyj üzenetet',
      SEND: 'Küldés',
      HOW_CAN_WE_REACH_YOU: 'Hogyan érhetjük el Önt?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Annak érdekében, hogy kapcsolatba léphessünk Veled kérjük, add meg adataidat',
      NAME: 'Név',
      PHONE: 'Telefon',
      EMAIL: 'Email',
      CHAT: 'Chat',
      WEBCALL: 'Web call',
      VIDEO: 'Videó',
      SCHEDULE: 'Időpont',
      WHATSAPP: 'Whatsapp',
      MESSENGER: 'Messenger',
      MESSAGE: 'Üzenet',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Mondj valamit',
      START_CHAT: 'Start Chat',
      CONTACT: 'Contact',
      ACTION_SELECTOR_HEADER: 'Welcome!',
      TEXT_CHAT_HEADER: 'Chat',
      WEBCALL_HEADER: 'Web call',
      WHATSAPP_HEADER: 'Whatsapp',
      FB_MESSENGER_HEADER: 'Messenger',
      SCHEDULE_MEETING_HEADER: 'Találkozó tervezése',
      PHONE_CALL_HEADER: 'Telefon',
      INFO_COLLECTOR_HEADER: 'Üzenet'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'Jelenleg nem vagyok elérhető',
      PLEASE_LEAVE_ME_A_MESSAGE: 'kérlek hagyj üzenetet',
      MESSAGE_STAR: 'Üzenet*',
      YOUR_MESSAGE_HERE: 'Üzeneted',
      NAME: 'Név',
      FIRST_NAME: 'Keresztnév',
      LAST_NAME: 'Vezetéknév',
      EMAIL: 'Email',
      INVALID_EMAIL: 'Érvénytelen e-mail',
      INVALID_PHONE_NUMBER: 'Érvénytelen telefonszám',
      OR: 'VAGY',
      SCHEDULE_A_MEETING: 'Találkozó foglalása',
      SEND_FB_MESSAGE: 'FB üzenet küldése',
      SEND_A_WHATSAPP: 'Küldj whatsapp -ot',
      PHONE: 'Telefon',
      PHONE_CALL: 'Hívás',
      SEND: 'Küld',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Mi a neved?',
      WHAT_IS_YOUR_EMAIL: 'Mi az e-mail címed?',
      WHAT_IS_YOUR_PHONE: 'Mi a telefonszámod?',
      WHAT_IS_YOUR_QUESTION: 'Mi a kérdésed?'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Tervezzük meg a találkozónkat',
      NEXT: 'Következő',
      BACK: 'Vissza',
      ADD_ANOTHER_OPTION: 'Adj hozzá egy másik lehetőséget',
      GIVE_ALTERNATIVES: 'Add meg néhány alternatívát az időpontfoglalás egyszerűbbé tételéhez',
      TIME_ZONE: 'Időzóna',
      WHAT_IS_YOUR_EMAIL: 'What is your email?',
      ADD_NOTE: 'Adj hozzá megjegyzést...',
      INVALID_EMAIL: 'Érvénytelen e-mail',
      THANKS_FOR_BOOKING: 'Köszönjük a foglalást',
      YOUR_REQUEST_WAS_SENT: '',
      WELL_GET_BACK: 'We’ll get back to you by mail.',
      CHOOSE_TIME: 'Choose time',
      ENTER_EMAIL: 'Enter your email',
      OPTIONAL: 'optional',
      WHEN_DO_YOU_WANT_TO_MEET: 'When do you want to meet? ',
      PICK_UP_TO_THREE: 'Pick up to three options for this meeting. Your client will need to approve one alternative',
      SEND_INVITATION: '',
      INVITATION_FAILED: 'Ohh ... valami baj történt ... Ellenőrizd, hogy a megbeszélések nem a múltban vannak -e',
      YOUR_NOTES: 'Jegyzeteid',
      YOUR_PROPOSED_TIMES: 'A javasolt találkozási idő',
      RESCHEDULE_MEETING: 'Találkozó átütemezése',
      CANCEL_MEETING: 'Az értekezlet megszakítása',
      DECLINE_MEETING: 'Visszautasítás',
      SURE_CANCEL: 'Biztosan törlöd ezt a találkozót?',
      YES_CANCEL: 'Igen, törlés',
      NEVER_MIND: 'Nem fontos',
      CANCELLED: 'Törölve',
      RESCHEDULED: 'Átütemezve',
      DECLINED: 'Elutasítva',
      CONFIRMED: 'Megerősítve',
      ADD_TO_CALENDAR: 'Hozzáadás a naptárhoz',
      REMOVE_FROM_CALENDAR: 'Eltávolítás a naptárból',
      SUGGEST_NEW_TIME: 'Javasolj új találkozási időpontot',
      SET_UPTO_THREE_OPTIONS: 'You can setup up to 3 options. One will be accepted.',
      REQUEST_SENT: 'Your request was sent',
      WAITING_FOR_APPROVAL: 'Waiting for approval.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Schedule another appointment',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SELECT_MEETING_DATE_AND_TIME: 'Select date and time',
      MEETING_DETAILS: 'Meeting Details'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Üdv, jelenleg nem vagyok elérhető.',
      LEAVE_MESSAGE: 'Hagyj üzenetet',
      OR: 'vagy',
      SCHEDULE_A_MEETING: 'Foglalj egy találkozó időpontot.',
      TRY_AGAIN: 'Próbáld újra',
      CALL_SETTINGS: 'Hívás beállítások',
      CAMERA: 'Kamera',
      MICROPHONE: 'Mikrofon',
      SPEAKERS: 'Hangszórók',
      CHAT: 'Chat',
      TEST: 'Teszt',
      VIDEO: 'Videó',
      AUDIO: 'Csak hang',
      SHARE_SCREEN: 'Képernyő megosztása',
      CONNECTING: 'Csatlakozás',
      RINGING: 'Hívás',
      SWITCH_CAMERA: 'Kamera átváltása',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Rakd le',
      ON_OFF: 'Ki/Be',
      PEER_IS_READY_PAYMENT: 'Készen állunk. Kérjük, indíts el a fizetést',
      PAY_NOW: 'Fizess most',
      CALL_END: 'Hívás vége :)',
      CALL_NOW: 'Call now',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Call Ended',
      SELF_CONNECTION_CLOSED: 'Call Ended',
      CAMERA_ACCESS_PREVENTED: "We couldn't get access to the camera and/or microphone on this device. Please enable them first.",
      CAMERA_ACCESS_DIALOG_OPEN: 'Please approve the camera and microphone in order to start a video call.',
      REJECTED_CALL_MESSAGE: 'Please try again later',
      SELF_CALL_MESSAGE: "We're sorry. \\n You are trying to call yourself.",
      SWITCHING: 'Switching',
      ONLY_YOU_STREAM: 'Only you stream',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: '',
      SECONDS: 'Másodperc',
      PEOPLE_RECEIVED_CALLS_TODAY: 'Hívások a mai napon fogadva',
      SECURED: 'Biztonságos',
      FROM: '',
      IS_CALLING_YOU: 'hív téged',
      OVER_A_SECURED_WEBCALL: 'biztonságos internetes híváson keresztül',
      ACCEPT: 'Elfogad',
      DECLINE: 'Elutasít',
      CALL_REQUEST: 'Híváskérésed van',
      PAYMENT_REQUEST: 'Fizetési kérésed van',
      PAY_NOW: 'Fizess most',
      CANCEL: 'Törlés',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  SPANISH: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Hablemos',
      MORE_INFO: 'más info',
      TALK_TO_ME_NOW: 'Hablemos ahora',
      FREE: '¡GRATIS!',
      MINUTES: 'Minutos',
      VIDEO_CALL: 'Videollamada',
      SCHEDULE_A_MEETING: 'Coordinar una reunión',
      SEND_FB_MESSAGE: 'Mensaje de FB',
      SEND_A_WHATSAPP: 'Whatsapp',
      PHONE_CALL: 'Llamar',
      YOUR_MESSAGE_HERE: 'Deja tu mensaje aqui',
      LEAVE_A_MESSAGE: 'Dejar un mensaje',
      SEND: 'Enviar',
      HOW_CAN_WE_REACH_YOU: '¿Cómo podemos contactarte?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Para poder responder por favor deje sus datos',
      NAME: 'Nombre',
      PHONE: 'Teléfono',
      EMAIL: 'Email ',
      CHAT: 'Chat',
      WEBCALL: 'Llamada Web',
      VIDEO: 'Video',
      SCHEDULE: 'Calendario',
      WHATSAPP: 'WhatsApp',
      MESSENGER: 'Messenger',
      MESSAGE: 'Mensaje',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Di algo',
      START_CHAT: 'Start Chat',
      CONTACT: 'Formulario',
      ACTION_SELECTOR_HEADER: 'Welcome!',
      TEXT_CHAT_HEADER: 'Chat',
      WEBCALL_HEADER: 'Llamada Web',
      WHATSAPP_HEADER: 'WhatsApp',
      FB_MESSENGER_HEADER: 'Messenger',
      SCHEDULE_MEETING_HEADER: 'Coordinar una reunión',
      PHONE_CALL_HEADER: 'Teléfono',
      INFO_COLLECTOR_HEADER: 'Formulario de contacto'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'No estoy disponible en este momento',
      PLEASE_LEAVE_ME_A_MESSAGE: 'Por favor dejame un mesage',
      MESSAGE_STAR: 'Mensaje*',
      YOUR_MESSAGE_HERE: 'Deja tu mensaje aquí',
      NAME: 'Nombre',
      FIRST_NAME: 'Primer nombre',
      LAST_NAME: 'Apellido',
      EMAIL: 'Email',
      INVALID_EMAIL: 'Correo electrónico invalido',
      INVALID_PHONE_NUMBER: 'Invalid phone number',
      OR: 'También puedes',
      SCHEDULE_A_MEETING: 'Coordinar una reunión',
      SEND_FB_MESSAGE: 'Enviar Mensaje de FB',
      SEND_A_WHATSAPP: 'Enviar Whatsapp',
      PHONE: 'Teléfono',
      PHONE_CALL: 'Llamar',
      SEND: 'Enviar',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Cuál es tu nombre?',
      WHAT_IS_YOUR_EMAIL: 'Cuál es tu correo electrónico?',
      WHAT_IS_YOUR_PHONE: 'Cuál es tu número de teléfono?',
      WHAT_IS_YOUR_QUESTION: 'Cuál es tu pregunta?'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Programemos nuestra reunión',
      NEXT: 'Siguiente',
      BACK: 'Volver',
      ADD_ANOTHER_OPTION: 'Agregar otra opción',
      GIVE_ALTERNATIVES: 'Ofrezca algunas alternativas para facilitar el flujo de programación',
      TIME_ZONE: 'Zona horaria',
      WHAT_IS_YOUR_EMAIL: 'Cuál es tu correo electrónico?',
      ADD_NOTE: 'Agregar una nota...',
      INVALID_EMAIL: 'Correo electrónico invalido',
      THANKS_FOR_BOOKING: 'Gracias por su reserva',
      YOUR_REQUEST_WAS_SENT: 'Su solicitud de reunión ha sido enviada y está esperando su aprobación.',
      WELL_GET_BACK: 'Lo(a) contactaremos por correo.',
      CHOOSE_TIME: 'Elija la hora',
      ENTER_EMAIL: 'Ingrese correo electrónico',
      OPTIONAL: 'opcional',
      WHEN_DO_YOU_WANT_TO_MEET: 'Cuándo quieres reunirte?',
      PICK_UP_TO_THREE: 'Pick up to three options for this meeting. Your client will need to approve one alternative',
      SEND_INVITATION: 'Enviar invitación',
      INVITATION_FAILED: 'Ups... algo salió mal... Por favor verifique que los horarios de las reuniones no hayan pasado',
      YOUR_NOTES: 'Tus notas',
      YOUR_PROPOSED_TIMES: 'Su hora de reunión propuesta',
      RESCHEDULE_MEETING: 'Reprogramar reunión',
      CANCEL_MEETING: 'Cancelar reunión',
      DECLINE_MEETING: 'Declinar reunión',
      SURE_CANCEL: '¿Estás seguro(a) de que deseas cancelar esta cita?',
      YES_CANCEL: 'Si, cancelar',
      NEVER_MIND: 'No importa',
      CANCELLED: 'Cancelado',
      RESCHEDULED: 'Reprogramado',
      DECLINED: 'Declinado',
      CONFIRMED: 'Confirmado',
      ADD_TO_CALENDAR: 'Agregar al calendario',
      REMOVE_FROM_CALENDAR: 'Remover del calendario',
      SUGGEST_NEW_TIME: 'Sugerir nueva hora para la reunión',
      SET_UPTO_THREE_OPTIONS: 'Puedes agregar hasta 3 opciones de cita, solo una será aceptada luego.',
      REQUEST_SENT: 'Su petición ha sido enviada',
      WAITING_FOR_APPROVAL: 'Esperando a ser aprobada.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Agendar otra cita o llamada',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SELECT_MEETING_DATE_AND_TIME: 'Select date and time',
      MEETING_DETAILS: 'Meeting Details'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Hola, no estoy disponible en este momento',
      LEAVE_MESSAGE: 'Dejame un mensaje',
      OR: 'o también',
      SCHEDULE_A_MEETING: 'Programar una reunión.',
      TRY_AGAIN: 'Intentar de nuevo',
      CALL_SETTINGS: 'Ajustes de Llamada',
      CAMERA: 'Cámara',
      MICROPHONE: 'Micrófono',
      SPEAKERS: 'Altavoces',
      CHAT: 'Chat',
      TEST: 'Prueba',
      VIDEO: 'Video',
      AUDIO: 'Solo audio',
      SHARE_SCREEN: 'Compartir pantalla',
      CONNECTING: 'Contectando',
      RINGING: 'Llamando',
      SWITCH_CAMERA: 'Cambiar cámara',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Colgar',
      ON_OFF: 'Off/On',
      PEER_IS_READY_PAYMENT: 'Your peer is ready. Please start payment',
      PAY_NOW: 'Pay now',
      CALL_END: 'Llamada finalizada',
      CALL_NOW: 'Call now',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Call Ended',
      SELF_CONNECTION_CLOSED: 'Call Ended',
      CAMERA_ACCESS_PREVENTED: "We couldn't get access to the camera and/or microphone on this device. Please enable them first.",
      CAMERA_ACCESS_DIALOG_OPEN: 'Por favor, autoriza el uso del micrófono y la cámara para iniciar la video llamada.',
      REJECTED_CALL_MESSAGE: 'Por favor, inténtalo de nuevo más tarde',
      SELF_CALL_MESSAGE: "We're sorry. \\n You are trying to call yourself.",
      SWITCHING: 'Switching',
      ONLY_YOU_STREAM: 'Only you stream',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'En',
      SECONDS: 'Segundos',
      PEOPLE_RECEIVED_CALLS_TODAY: 'Personas recibieron llamadas hoy ',
      SECURED: 'Asegurado',
      FROM: 'Desde',
      IS_CALLING_YOU: 'te está llamando',
      OVER_A_SECURED_WEBCALL: 'a través de una llamada web segura',
      ACCEPT: 'Aceptar',
      DECLINE: 'Rechazar',
      CALL_REQUEST: 'Estás recibiendo una llamada',
      PAYMENT_REQUEST: 'You have a payment request',
      PAY_NOW: 'Pay now',
      CANCEL: 'Cancel',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  PORTUGUES: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Vamos conversar',
      MORE_INFO: 'saiba mais',
      TALK_TO_ME_NOW: 'Vamos conversar agora',
      FREE: 'GRÁTIS! ',
      MINUTES: 'Minutos',
      VIDEO_CALL: 'Vídeo Chamada',
      SCHEDULE_A_MEETING: 'Agendar Reunião',
      SEND_FB_MESSAGE: 'Falar por Facebook',
      SEND_A_WHATSAPP: 'Falar por Whatsapp',
      PHONE_CALL: 'Ligue',
      YOUR_MESSAGE_HERE: 'Deixe sua mensagem aqui',
      LEAVE_A_MESSAGE: 'Deixar uma mensagem',
      SEND: 'Enviar',
      HOW_CAN_WE_REACH_YOU: 'Como podemos entrar em contato com você?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Para que possamos retornar, por favor, informe seus dados de contato.',
      NAME: 'Nome',
      PHONE: 'Telefone',
      EMAIL: 'E-mail ',
      CHAT: 'Chat ',
      WEBCALL: 'Web Chamada',
      VIDEO: 'Vídeo',
      SCHEDULE: 'Calendário',
      WHATSAPP: 'WhatsApp',
      MESSENGER: 'Messenger',
      MESSAGE: 'Mensagem',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Diga algo',
      START_CHAT: 'Começar chat',
      CONTACT: 'Contatar',
      ACTION_SELECTOR_HEADER: 'Bem vindo a Consolto',
      TEXT_CHAT_HEADER: 'Chat ',
      WEBCALL_HEADER: 'Web Chamada',
      WHATSAPP_HEADER: 'WhatsApp',
      FB_MESSENGER_HEADER: 'Messenger',
      SCHEDULE_MEETING_HEADER: 'Agendar Reunião',
      PHONE_CALL_HEADER: 'Telefone',
      INFO_COLLECTOR_HEADER: 'Mensagem'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'Não estou disponível agora',
      PLEASE_LEAVE_ME_A_MESSAGE: 'Favor deixar uma mensagem',
      MESSAGE_STAR: 'Mensagem*',
      YOUR_MESSAGE_HERE: 'Deixe sua mensagem aqui',
      NAME: 'Nome',
      FIRST_NAME: 'Primeiro Nome',
      LAST_NAME: 'Sobrenome',
      EMAIL: 'E-mail',
      INVALID_EMAIL: 'E-mail Inválido',
      INVALID_PHONE_NUMBER: 'Número de Telefone Inválido',
      OR: 'Você também pode',
      SCHEDULE_A_MEETING: 'Agendar uma Reunião',
      SEND_FB_MESSAGE: 'Falar pelo Facebook',
      SEND_A_WHATSAPP: 'Falar por Whatsapp',
      PHONE: 'Telefonar',
      PHONE_CALL: 'Ligar',
      SEND: 'Enviar',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Qual é o seu nome?',
      WHAT_IS_YOUR_EMAIL: 'Qual é o seu e-mail?',
      WHAT_IS_YOUR_PHONE: 'Qual é o seu telefone?',
      WHAT_IS_YOUR_QUESTION: 'Qual é a sua pergunta?'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Vamos agendar nossa reunião',
      NEXT: 'Próximo',
      BACK: 'Voltar',
      ADD_ANOTHER_OPTION: 'Adicionar outra opção',
      GIVE_ALTERNATIVES: 'Adicione outras sugestões para facilitar seu agendamento',
      TIME_ZONE: 'Fuso Horário',
      WHAT_IS_YOUR_EMAIL: 'Qual é o seu e-mail?',
      ADD_NOTE: 'Adicione uma nota',
      INVALID_EMAIL: 'E-mail inválido',
      THANKS_FOR_BOOKING: 'Obrigado por agendar',
      YOUR_REQUEST_WAS_SENT: 'Sua solicitação foi enviada e está aguardando aprovação',
      WELL_GET_BACK: 'Entraremos em contato com você por e-mail.',
      CHOOSE_TIME: 'Escolha o horário',
      ENTER_EMAIL: 'Entre com o seu e-mail',
      OPTIONAL: 'opcional',
      WHEN_DO_YOU_WANT_TO_MEET: 'Para quando você deseja agendar?',
      PICK_UP_TO_THREE: 'Escolha até três opções para a reunião. Seu cliente terá que aprovar uma delas.',
      SEND_INVITATION: 'Agendar',
      INVITATION_FAILED: 'Ocorreu um erro, favor conferir se os horários da reunião não estão em datas passadas',
      YOUR_NOTES: 'Suas anotações',
      YOUR_PROPOSED_TIMES: 'Seu horário sugerido para reunião',
      RESCHEDULE_MEETING: 'Reagendar reunião',
      CANCEL_MEETING: 'Cancelar reunião',
      DECLINE_MEETING: 'Recusar reunião',
      SURE_CANCEL: 'Tem certeza que deseja cancelar este agendamento?',
      YES_CANCEL: 'Sim, cancelar',
      NEVER_MIND: 'Ignorar',
      CANCELLED: 'Cancelado',
      RESCHEDULED: 'Reagendado',
      DECLINED: 'Recusado',
      CONFIRMED: 'Confirmado',
      ADD_TO_CALENDAR: 'Adicionar ao calendário',
      REMOVE_FROM_CALENDAR: 'Remover do calendário',
      SUGGEST_NEW_TIME: 'Sugerir um novo horário para reunião',
      SET_UPTO_THREE_OPTIONS: 'Você pode escolher até 3 opções. Uma será aceita',
      REQUEST_SENT: 'Seu pedido foi enviado',
      WAITING_FOR_APPROVAL: 'Esperando aprovação',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Agendar outra chamada',
      EDIT: 'Editar',
      DELETE: 'Deletar',
      SELECT_MEETING_DATE_AND_TIME: 'Selecione data e horário',
      MEETING_DETAILS: 'Detalhes da reunião'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Olá, não estou disponível no momento. ',
      LEAVE_MESSAGE: 'Deixe sua mensagem',
      OR: 'ou',
      SCHEDULE_A_MEETING: 'Agendar uma reunião',
      TRY_AGAIN: 'Tente novamente',
      CALL_SETTINGS: 'Ajustes da Chamada',
      CAMERA: 'Câmera',
      MICROPHONE: 'Microfone',
      SPEAKERS: 'Auto-Falantes',
      CHAT: 'Chat',
      TEST: 'Testar',
      VIDEO: 'Vídeo',
      AUDIO: 'Somente Áudio',
      SHARE_SCREEN: 'Compartilhar a Tela',
      CONNECTING: 'Conectando',
      RINGING: 'Tocando',
      SWITCH_CAMERA: 'Mudar de Câmera',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Desligar',
      ON_OFF: 'Desligar/Ligar',
      PEER_IS_READY_PAYMENT: 'Para iniciar, por favor, realize o pagamento.',
      PAY_NOW: 'Pagar agora',
      CALL_END: 'Ligação Finalizada :)',
      CALL_NOW: 'Ligar agora',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Ligação encerrada',
      SELF_CONNECTION_CLOSED: 'Ligação encerrada',
      CAMERA_ACCESS_PREVENTED: 'Não conseguimos acessar a câmera e/ou microfone neste aparelho. Favor habilitar acesso antes.',
      CAMERA_ACCESS_DIALOG_OPEN: 'Por favor aprove a câmera e o microfone para iniciar chamada',
      REJECTED_CALL_MESSAGE: 'Por favor tente novamente mais tarde',
      SELF_CALL_MESSAGE: 'Desculpe, você está tentando ligar para si mesmo',
      SWITCHING: 'Trocando',
      ONLY_YOU_STREAM: 'Apenas você transmitindo',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'Em',
      SECONDS: 'Segundos',
      PEOPLE_RECEIVED_CALLS_TODAY: 'Pessoas receberam chamadas hoje',
      SECURED: 'Seguro',
      FROM: 'De',
      IS_CALLING_YOU: 'está chamando você',
      OVER_A_SECURED_WEBCALL: 'através de uma chamada web segura',
      ACCEPT: 'Aceitar',
      DECLINE: 'Rejeitar',
      CALL_REQUEST: 'Você tem uma solicitação de chamada',
      PAYMENT_REQUEST: 'Você tem uma nova solicitação de pagamento',
      PAY_NOW: 'Pagar Agora',
      CANCEL: 'Cancelar',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  TURKISH: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Hadi Konuşalım',
      MORE_INFO: 'Daha fazla bilgi',
      TALK_TO_ME_NOW: 'Sohbeti Başlat',
      FREE: 'Ücretsiz',
      MINUTES: 'Dakika',
      VIDEO_CALL: 'Video Arama',
      SCHEDULE_A_MEETING: 'Randevu Oluştur',
      SEND_FB_MESSAGE: 'Facebook Mesajı Gönder',
      SEND_A_WHATSAPP: 'Whats App Mesajı Gönder',
      PHONE_CALL: 'Telefon Araması Yap',
      YOUR_MESSAGE_HERE: 'Mesajını Buraya Yaz',
      LEAVE_A_MESSAGE: 'Bir mesaj bırakın',
      SEND: 'Gönder',
      HOW_CAN_WE_REACH_YOU: 'Size Nasıl Ulaşabiliriz?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Size Geri Dönüş Sağlamak için lütfen bilgilerinize bırakın',
      NAME: 'İsim',
      PHONE: 'Telefon ',
      EMAIL: 'Email ',
      CHAT: 'Sohbet',
      WEBCALL: 'İnternet Araması',
      VIDEO: 'Video',
      SCHEDULE: 'Randevu',
      WHATSAPP: 'WhatsApp',
      MESSENGER: 'FB-Messenger',
      MESSAGE: 'Mesaj',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Bir şey söyle',
      START_CHAT: 'Start Chat',
      CONTACT: 'Contact',
      ACTION_SELECTOR_HEADER: 'Welcome!',
      TEXT_CHAT_HEADER: 'Sohbet',
      WEBCALL_HEADER: 'İnternet Araması',
      WHATSAPP_HEADER: 'WhatsApp',
      FB_MESSENGER_HEADER: 'FB-Messenger',
      SCHEDULE_MEETING_HEADER: 'Randevu Oluştur',
      PHONE_CALL_HEADER: 'Telefon ',
      INFO_COLLECTOR_HEADER: 'Mesaj'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'Müsait Değilim',
      PLEASE_LEAVE_ME_A_MESSAGE: 'Lütfen Mesaj Bırakın!',
      MESSAGE_STAR: 'Mesaj*',
      YOUR_MESSAGE_HERE: 'Mesajını Buraya Yazınız',
      NAME: 'İsim',
      FIRST_NAME: 'İsim',
      LAST_NAME: 'Soyisim',
      EMAIL: 'E-posta',
      INVALID_EMAIL: 'Geçersiz email adresi',
      INVALID_PHONE_NUMBER: 'Geçersiz telefon numarası',
      OR: 'veya',
      SCHEDULE_A_MEETING: 'Randevu Oluştur',
      SEND_FB_MESSAGE: 'Facebook Mesajı Gönder',
      SEND_A_WHATSAPP: 'Whats App Mesajı Gönder',
      PHONE: 'Telefon',
      PHONE_CALL: 'Telefon Araması',
      SEND: 'Gönder',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Adınız?',
      WHAT_IS_YOUR_EMAIL: 'Email adresiniz?',
      WHAT_IS_YOUR_PHONE: 'Telefon numaranız?',
      WHAT_IS_YOUR_QUESTION: 'Sorunuz nedir?'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Hadi toplantı planlayalım',
      NEXT: 'İleri',
      BACK: 'Geri',
      ADD_ANOTHER_OPTION: 'Başka seçenek ekle',
      GIVE_ALTERNATIVES: 'Daha kolay toplantı oluşturmak için birkaç alternatif verin',
      TIME_ZONE: 'Saat dilimi',
      WHAT_IS_YOUR_EMAIL: 'Email adresiniz?',
      ADD_NOTE: 'Bir not ekleyiniz.',
      INVALID_EMAIL: 'Geçersiz email adresi',
      THANKS_FOR_BOOKING: 'Rezervasyonunuz için teşekkürler.',
      YOUR_REQUEST_WAS_SENT: 'Toplantı isteğiniz gönderildi ve onay bekliyor',
      WELL_GET_BACK: 'Mail ile size geri dönüş yapacağız.',
      CHOOSE_TIME: 'Zaman seç.',
      ENTER_EMAIL: 'Email adresi gir.',
      OPTIONAL: 'Opsiyonlu',
      WHEN_DO_YOU_WANT_TO_MEET: 'Ne zaman görüşmek istersiniz?',
      PICK_UP_TO_THREE: 'Bu toplantı için en fazla üç seçenek seçin. Müşterinizin bir alternatifi onaylaması gerekecek.',
      SEND_INVITATION: 'Davetiye gönder.',
      INVITATION_FAILED: 'Ups.. bir şeyler ters gitti ... Lütfen toplantı zamanlarının geçmişte olmadığını kontrol edin',
      YOUR_NOTES: 'Notunuz.',
      YOUR_PROPOSED_TIMES: 'Size önerilen toplantı süresi',
      RESCHEDULE_MEETING: 'Toplantıyı yeniden zamanla.',
      CANCEL_MEETING: 'Toplantıyı iptal et.',
      DECLINE_MEETING: 'Reddet',
      SURE_CANCEL: 'Bu randevuyu iptal etmek istediğinizden eminmisiniz?',
      YES_CANCEL: 'Evet, İptal Et',
      NEVER_MIND: 'Önemli Değil.',
      CANCELLED: 'İptal edildi.',
      RESCHEDULED: 'Ertelemek',
      DECLINED: 'Reddedildi.',
      CONFIRMED: 'Onaylanmış',
      ADD_TO_CALENDAR: 'Takvime ekle.',
      REMOVE_FROM_CALENDAR: 'Takvimden kaldır.',
      SUGGEST_NEW_TIME: 'Toplantı için yeni zaman önerin',
      SET_UPTO_THREE_OPTIONS: 'You can setup up to 3 options. One will be accepted.',
      REQUEST_SENT: 'Your request was sent',
      WAITING_FOR_APPROVAL: 'Waiting for approval.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Schedule another appointment',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SELECT_MEETING_DATE_AND_TIME: 'Select date and time',
      MEETING_DETAILS: 'Meeting Details'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Merhaba, şu anda çevrimdışıyım',
      LEAVE_MESSAGE: 'Mesaj bırakabilir',
      OR: 'veya',
      SCHEDULE_A_MEETING: 'görüşme için randevu oluşturabilirsiniz.',
      TRY_AGAIN: 'Yeniden deneyin.',
      CALL_SETTINGS: 'Arama ayarları',
      CAMERA: 'Kamera',
      MICROPHONE: 'Mikrofon',
      SPEAKERS: 'Hoparlörler',
      CHAT: 'Chat',
      TEST: 'Test',
      VIDEO: 'Video',
      AUDIO: 'Yalnızca Ses',
      SHARE_SCREEN: 'Ekranı paylaş',
      CONNECTING: 'Bağlanıyor',
      RINGING: 'Zil sesi',
      SWITCH_CAMERA: 'Kamerayı değiştir.',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Telefonu kapat',
      ON_OFF: 'Off/On',
      PEER_IS_READY_PAYMENT: 'Your peer is ready. Please start payment',
      PAY_NOW: 'Pay now',
      CALL_END: 'Call End :)',
      CALL_NOW: 'Call now',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Call Ended',
      SELF_CONNECTION_CLOSED: 'Call Ended',
      CAMERA_ACCESS_PREVENTED: "We couldn't get access to the camera and/or microphone on this device. Please enable them first.",
      CAMERA_ACCESS_DIALOG_OPEN: 'Please approve the camera and microphone in order to start a video call.',
      REJECTED_CALL_MESSAGE: 'Please try again later',
      SELF_CALL_MESSAGE: "We're sorry. \\n You are trying to call yourself.",
      SWITCHING: 'Switching',
      ONLY_YOU_STREAM: 'Only you stream',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'Çevrimiçi',
      SECONDS: 'Saniye',
      PEOPLE_RECEIVED_CALLS_TODAY: 'Bugün Arama Kabul Edenler',
      SECURED: 'Güvenli',
      FROM: 'Buradan',
      IS_CALLING_YOU: 'Sizi Arıyor',
      OVER_A_SECURED_WEBCALL: 'Güvenli İnternet Araması',
      ACCEPT: 'Kabul Et',
      DECLINE: 'Reddet',
      CALL_REQUEST: 'You have a call request',
      PAYMENT_REQUEST: 'You have a payment request',
      PAY_NOW: 'Pay now',
      CANCEL: 'Cancel',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  JAPANESE: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'ご相談ください。',
      MORE_INFO: '詳細は、こちら',
      TALK_TO_ME_NOW: '今すぐご相談出来ます。',
      FREE: '無料です。',
      MINUTES: '分',
      VIDEO_CALL: 'ビデオ電話',
      SCHEDULE_A_MEETING: 'スケジュール',
      SEND_FB_MESSAGE: 'FBメッセンジャーで送信',
      SEND_A_WHATSAPP: 'ワッツアップで送信',
      PHONE_CALL: '電話',
      YOUR_MESSAGE_HERE: 'メッセージの送信',
      LEAVE_A_MESSAGE: 'メッセージを残してください。',
      SEND: '送信する',
      HOW_CAN_WE_REACH_YOU: 'やり取りの方法は?',
      IN_ORDER_TO_GET_BACK_TO_YOU: '折り返しご連絡致します。',
      NAME: 'お名前',
      PHONE: '電話番号',
      EMAIL: 'メールアドレス',
      CHAT: 'チャット',
      WEBCALL: 'ウェブ電話',
      VIDEO: 'ビデオ',
      SCHEDULE: 'スケジュール',
      WHATSAPP: 'ワッツアップ',
      MESSENGER: 'メッセンジャー',
      MESSAGE: 'メッセージ',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: '何か言ってください',
      START_CHAT: 'チャットを始めます',
      CONTACT: '連絡先',
      ACTION_SELECTOR_HEADER: 'ようこそ！',
      TEXT_CHAT_HEADER: 'チャット',
      WEBCALL_HEADER: 'ウェブ電話',
      WHATSAPP_HEADER: 'ワッツアップ',
      FB_MESSENGER_HEADER: 'メッセンジャー',
      SCHEDULE_MEETING_HEADER: 'スケジュール',
      PHONE_CALL_HEADER: '電話番号',
      INFO_COLLECTOR_HEADER: 'お問い合わせフォーム'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: '現在 ご利用出来ません。',
      PLEASE_LEAVE_ME_A_MESSAGE: 'メッセージをお残しください。',
      MESSAGE_STAR: 'メッセージ',
      YOUR_MESSAGE_HERE: 'こちらにメッセージを入力',
      NAME: 'お名前',
      FIRST_NAME: '名前',
      LAST_NAME: '名字',
      EMAIL: 'メールアドレス',
      INVALID_EMAIL: '無効なメールアドレス',
      INVALID_PHONE_NUMBER: '無効な電話番号',
      OR: 'あるいは',
      SCHEDULE_A_MEETING: '打合せの予定',
      SEND_FB_MESSAGE: 'FBメッセンジャーで送信',
      SEND_A_WHATSAPP: 'ワッツアップで送信',
      PHONE: 'お電話',
      PHONE_CALL: '電話',
      SEND: '送信',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'お名前は？',
      WHAT_IS_YOUR_EMAIL: 'メールアドレスは？',
      WHAT_IS_YOUR_PHONE: '電話番号は？',
      WHAT_IS_YOUR_QUESTION: 'ご質問は？'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'ミーティングを予約しよう',
      NEXT: '次へ',
      BACK: '戻る',
      ADD_ANOTHER_OPTION: '別のオプションを追加する',
      GIVE_ALTERNATIVES: 'スケジュール調整をし易くするために、いくつかの選択肢をあげる',
      TIME_ZONE: '時間帯',
      WHAT_IS_YOUR_EMAIL: 'メールアドレスは？',
      ADD_NOTE: 'メモを追加する',
      INVALID_EMAIL: '無効なメールアドレス',
      THANKS_FOR_BOOKING: 'ご予約ありがとうございます。',
      YOUR_REQUEST_WAS_SENT: 'ミーティングの希望は送られました、承認を待っています。',
      WELL_GET_BACK: 'メールにてお返事します。',
      CHOOSE_TIME: '時間を選んでください。',
      ENTER_EMAIL: 'メールアドレスを入れてください。',
      OPTIONAL: 'オプション',
      WHEN_DO_YOU_WANT_TO_MEET: 'いつ会いたいですか？',
      PICK_UP_TO_THREE: 'このミーティングの選択肢を3つまで選んでください。クライアントは1つの選択肢を承認する必要があります。',
      SEND_INVITATION: '招待状を送る',
      INVITATION_FAILED: '何かおかしいです。ミーティング時間が過去になっていないか確認してください。',
      YOUR_NOTES: 'メモ',
      YOUR_PROPOSED_TIMES: 'ご希望のミーティング時間',
      RESCHEDULE_MEETING: 'ミーティングの再スケジュール',
      CANCEL_MEETING: 'ミーティングのキャンセル',
      DECLINE_MEETING: '辞退',
      SURE_CANCEL: '本当にキャンセルしますか？',
      YES_CANCEL: 'はい、キャンセルします。',
      NEVER_MIND: '気にしないで',
      CANCELLED: 'キャンセルされました。',
      RESCHEDULED: '予定が変更されました。',
      DECLINED: '辞退された',
      CONFIRMED: '確認されました。',
      ADD_TO_CALENDAR: 'カレンダーに追加',
      REMOVE_FROM_CALENDAR: 'カレンダーから削除',
      SUGGEST_NEW_TIME: '新しいミーティング時間を提案する',
      SET_UPTO_THREE_OPTIONS: 'オプションは3つまで設定できます。1つでも受け付けます。',
      REQUEST_SENT: 'リクエストが送信されました。',
      WAITING_FOR_APPROVAL: '承認待ち',
      SCHEDULE_ANOTHER_APPOINTMENT: '別の予約を入れる。',
      EDIT: '編集',
      DELETE: '削除',
      SELECT_MEETING_DATE_AND_TIME: '日時の選択',
      MEETING_DETAILS: 'ミーティングの詳細'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'ただいま留守にしています。',
      LEAVE_MESSAGE: 'メッセージをどうぞ。',
      OR: 'または',
      SCHEDULE_A_MEETING: 'ミーティングを予定する。',
      TRY_AGAIN: '再試行してください。',
      CALL_SETTINGS: '通話設定',
      CAMERA: 'カメラ',
      MICROPHONE: 'マイク',
      SPEAKERS: 'スピーカー',
      CHAT: 'Chat',
      TEST: 'テスト',
      VIDEO: 'ビデオ',
      AUDIO: 'オーディオのみ',
      SHARE_SCREEN: '画面を共有する。',
      CONNECTING: '接続中',
      RINGING: '呼び出し音',
      SWITCH_CAMERA: 'カメラを替える',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: '切る',
      ON_OFF: 'オフ / オン',
      PEER_IS_READY_PAYMENT: '準備が整いました。お支払いを開始してください。',
      PAY_NOW: '今、支払う',
      CALL_END: '電話終了',
      CALL_NOW: '今すぐ通話を',
      PEER_CONNECTION_CLOSED_MESSAGE: '電話終了',
      SELF_CONNECTION_CLOSED: '電話終了',
      CAMERA_ACCESS_PREVENTED: 'このデバイスのカメラおよび/またはマイクにアクセスできませんでした。まずそれらを有効にしてください。',
      CAMERA_ACCESS_DIALOG_OPEN: 'ビデオ通話を開始するには、カメラとマイクを承認してください。',
      REJECTED_CALL_MESSAGE: '後でもう一度お試しください。',
      SELF_CALL_MESSAGE: '申し訳ございません。自分自身に電話をかけようとしています。',
      SWITCHING: 'スイッチング',
      ONLY_YOU_STREAM: 'あなただけストリーミング',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'で',
      SECONDS: '秒',
      PEOPLE_RECEIVED_CALLS_TODAY: '今日電話を受けた人',
      SECURED: '安心・安全な',
      FROM: 'から',
      IS_CALLING_YOU: 'ご連絡致します。',
      OVER_A_SECURED_WEBCALL: '安全なウェブ通話で',
      ACCEPT: '承認します',
      DECLINE: '承認しません',
      CALL_REQUEST: '通話希望が来ています。',
      PAYMENT_REQUEST: '支払い要求があります。',
      PAY_NOW: '今、支払う。',
      CANCEL: 'キャンセル',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  FRENCH: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Discutons',
      MORE_INFO: "Plus d'info",
      TALK_TO_ME_NOW: 'Discutons maintenant',
      FREE: 'GRATUIT!!',
      MINUTES: 'Minutes',
      VIDEO_CALL: 'Appel Vidéo',
      SCHEDULE_A_MEETING: 'Organiser un RDV',
      SEND_FB_MESSAGE: 'Envoyer un message FB',
      SEND_A_WHATSAPP: 'Envoyer un message Whatsapp',
      PHONE_CALL: 'Appel',
      YOUR_MESSAGE_HERE: 'Laissez votre message ici',
      LEAVE_A_MESSAGE: 'Laisser un message',
      SEND: 'Envoyer',
      HOW_CAN_WE_REACH_YOU: 'Comment vous joindre?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Laissez vos détail que nous puissions vous contacter',
      NAME: 'Nom',
      PHONE: 'Téléphone',
      EMAIL: 'Email',
      CHAT: 'Chat',
      WEBCALL: 'Appel Web',
      VIDEO: 'Vidéo',
      SCHEDULE: 'Agenda',
      WHATSAPP: 'WhatsApp',
      MESSENGER: 'Messenger',
      MESSAGE: 'Message',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Dites quelque chose',
      START_CHAT: 'Démarrer le Chat',
      CONTACT: 'Contact',
      ACTION_SELECTOR_HEADER: 'Bienvenue!',
      TEXT_CHAT_HEADER: 'Chat',
      WEBCALL_HEADER: 'Appel Web',
      WHATSAPP_HEADER: 'WhatsApp',
      FB_MESSENGER_HEADER: 'Messenger',
      SCHEDULE_MEETING_HEADER: 'Organiser un RDV',
      PHONE_CALL_HEADER: 'Téléphone',
      INFO_COLLECTOR_HEADER: 'Message'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'Je ne suis pas disponible',
      PLEASE_LEAVE_ME_A_MESSAGE: 'Merci de laisser un message',
      MESSAGE_STAR: 'Message*',
      YOUR_MESSAGE_HERE: 'Votre message ici',
      NAME: 'Nom',
      FIRST_NAME: 'Prénom',
      LAST_NAME: 'Nom de famille',
      EMAIL: 'Email',
      INVALID_EMAIL: 'Adresse mail invalide',
      INVALID_PHONE_NUMBER: 'Numéro de téléphone invalide',
      OR: 'Ou',
      SCHEDULE_A_MEETING: 'Organiser un RDV',
      SEND_FB_MESSAGE: 'Envoyer un message FB',
      SEND_A_WHATSAPP: 'Envoyer un message whatsapp',
      PHONE: 'Téléphone',
      PHONE_CALL: 'Appel',
      SEND: 'Envoyer',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Votre nom?',
      WHAT_IS_YOUR_EMAIL: 'Votre email?',
      WHAT_IS_YOUR_PHONE: 'Votre téléphone?',
      WHAT_IS_YOUR_QUESTION: 'Quelle est votre question?'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Organisons un RDV',
      NEXT: 'Suivant',
      BACK: 'Retour',
      ADD_ANOTHER_OPTION: 'Ajouter une autre option',
      GIVE_ALTERNATIVES: "Donnez quelques possibilités afin de faciliter l'organisation",
      TIME_ZONE: 'Fuseau horaire',
      WHAT_IS_YOUR_EMAIL: 'Votre email?',
      ADD_NOTE: 'Ajouter un commentaire',
      INVALID_EMAIL: 'Adresse mail invalide',
      THANKS_FOR_BOOKING: 'Merci pour votre réservation',
      YOUR_REQUEST_WAS_SENT: 'Votre demande de RDV a été envoyée et est en attente de confirmation',
      WELL_GET_BACK: 'Nous vous contacterons par email',
      CHOOSE_TIME: "Choisissez l'heure",
      ENTER_EMAIL: '',
      OPTIONAL: 'Optionnel',
      WHEN_DO_YOU_WANT_TO_MEET: 'Quand souhaitez vous une rencontre',
      PICK_UP_TO_THREE: "Choisissez jusqu'à trois options pour cette réunion. Votre client devra approuver un des choix",
      SEND_INVITATION: 'Envoyer une invitation',
      INVITATION_FAILED: "Zut... il y a une erreur, veuillez vérifier que votre RDV n'est pas à une date antérieur d'aujourd'hui",
      YOUR_NOTES: 'Vos commentaires',
      YOUR_PROPOSED_TIMES: 'Heure de RDV proposée',
      RESCHEDULE_MEETING: 'Organiser un RDV',
      CANCEL_MEETING: 'Annuler le RDV',
      DECLINE_MEETING: 'Refuser',
      SURE_CANCEL: 'Êtes vous sur de vouloir annuler ce RDV',
      YES_CANCEL: 'Oui, annuler',
      NEVER_MIND: 'Oublier',
      CANCELLED: 'Annulé',
      RESCHEDULED: 'Reporté',
      DECLINED: 'Refusé',
      CONFIRMED: 'Confirmé',
      ADD_TO_CALENDAR: 'Ajouter au calendrier',
      REMOVE_FROM_CALENDAR: 'Enlever du calendrier',
      SUGGEST_NEW_TIME: 'Suggérer une nouvelle heure de RDV',
      SET_UPTO_THREE_OPTIONS: 'Vous pouvez choisir 3 options. Une option sera acceptée.',
      REQUEST_SENT: 'Votre demande a été envoyée',
      WAITING_FOR_APPROVAL: "En attente d'une confirmation.",
      SCHEDULE_ANOTHER_APPOINTMENT: 'Planifier un autre rendez-vous',
      EDIT: 'Editer',
      DELETE: 'Supprimer',
      SELECT_MEETING_DATE_AND_TIME: 'Sélectionner date et heure',
      MEETING_DETAILS: 'Détails du rendez-vous'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Je ne suis pas disponible pour le moment',
      LEAVE_MESSAGE: 'Laissez moi un message',
      OR: 'ou',
      SCHEDULE_A_MEETING: 'Programmer un RDV',
      TRY_AGAIN: 'Réessayer',
      CALL_SETTINGS: "Configuration de l'appel",
      CAMERA: 'Caméra',
      MICROPHONE: 'Micro',
      SPEAKERS: 'Hauts parleurs',
      CHAT: 'Chat',
      TEST: 'Test',
      VIDEO: 'Vidéo',
      AUDIO: 'Son seulement',
      SHARE_SCREEN: "Partager l'écran",
      CONNECTING: 'En cours de connexion',
      RINGING: 'Sonnerie',
      SWITCH_CAMERA: 'Changer de caméra',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Raccrocher',
      ON_OFF: 'Off/On',
      PEER_IS_READY_PAYMENT: 'Votre partenaire est prêt. Veuillez commencer le paiement',
      PAY_NOW: 'Payer maintenant',
      CALL_END: 'Appel terminé :)',
      CALL_NOW: 'Appeler maintenant',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Appel terminé',
      SELF_CONNECTION_CLOSED: 'Appel terminé',
      CAMERA_ACCESS_PREVENTED: "Nous n'avons pas pu accéder à la caméra et/ou au microphone de cet appareil. Veuillez d'abord les activer.",
      CAMERA_ACCESS_DIALOG_OPEN: 'Veuillez autoriser la caméra et le microphone afin de démarrer un appel vidéo.',
      REJECTED_CALL_MESSAGE: 'Veuillez réessayer plus tard',
      SELF_CALL_MESSAGE: 'Nous sommes désolés. \\n Vous essayez de vous appeler vous-même.',
      SWITCHING: 'Switching',
      ONLY_YOU_STREAM: 'Only you stream',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'en',
      SECONDS: 'Secondes',
      PEOPLE_RECEIVED_CALLS_TODAY: "Appels reçu aujourd'hui",
      SECURED: 'Sécurisé',
      FROM: 'De',
      IS_CALLING_YOU: 'vous appelle',
      OVER_A_SECURED_WEBCALL: 'Par appel sécurisé',
      ACCEPT: 'Accepter',
      DECLINE: 'Refuser',
      CALL_REQUEST: "Vous avez une demande d'appel",
      PAYMENT_REQUEST: 'Vous avez une demande de paiement',
      PAY_NOW: 'Payer maintenant',
      CANCEL: 'Annuler',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  GERMAN: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Lassen Sie uns chatten',
      MORE_INFO: 'Mehr Info',
      TALK_TO_ME_NOW: 'Sprechen wir miteinander',
      FREE: 'KOSTENLOS',
      MINUTES: 'Minuten',
      VIDEO_CALL: 'Video-Anruf',
      SCHEDULE_A_MEETING: 'Einen Termin vereinbaren',
      SEND_FB_MESSAGE: 'Eine Facebook-Nachricht senden',
      SEND_A_WHATSAPP: 'Eine Whatsapp Nachricht senden',
      PHONE_CALL: 'Anruf',
      YOUR_MESSAGE_HERE: 'Ihre Nachricht',
      LEAVE_A_MESSAGE: 'Hinterlassen Sie Ihre Nachricht',
      SEND: 'Senden',
      HOW_CAN_WE_REACH_YOU: 'Wie können wir sie erreichen?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Bitte teilen Sie uns mit, wie wir Sie erreichen können',
      NAME: 'Name',
      PHONE: 'Telefon-Nr',
      EMAIL: 'Email',
      CHAT: 'Chat',
      WEBCALL: 'Web-Anruf',
      VIDEO: 'Video ',
      SCHEDULE: 'Terminplan',
      WHATSAPP: 'WhatsApp',
      MESSENGER: 'FB-Messenger',
      MESSAGE: 'Nachricht',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Ihre Nachricht',
      START_CHAT: 'Start Chat',
      CONTACT: 'Contact',
      ACTION_SELECTOR_HEADER: 'Welcome!',
      TEXT_CHAT_HEADER: 'Chat',
      WEBCALL_HEADER: 'Web-Anruf',
      WHATSAPP_HEADER: 'WhatsApp',
      FB_MESSENGER_HEADER: 'FB-Messenger',
      SCHEDULE_MEETING_HEADER: 'Einen Termin vereinbaren',
      PHONE_CALL_HEADER: 'Telefon-Nr',
      INFO_COLLECTOR_HEADER: 'Nachricht'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'Im Moment sind wir online nicht erreichbar',
      PLEASE_LEAVE_ME_A_MESSAGE: 'Bitte hinterlassen Sie eine Nachricht',
      MESSAGE_STAR: 'Nachricht*',
      YOUR_MESSAGE_HERE: 'Hier Ihre Nachricht',
      NAME: 'Name',
      FIRST_NAME: 'Vorname',
      LAST_NAME: 'Nachname',
      EMAIL: 'Email',
      INVALID_EMAIL: 'Email ungültig',
      INVALID_PHONE_NUMBER: 'Falsche Telefonnummer',
      OR: 'Oder',
      SCHEDULE_A_MEETING: 'Einen Termin planen',
      SEND_FB_MESSAGE: 'Facebook-Nachricht schicken',
      SEND_A_WHATSAPP: 'Eine Whatsapp-Nachricht senden',
      PHONE: 'Telephon-Nr',
      PHONE_CALL: 'Anruf',
      SEND: 'Senden',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Wie ist Ihr Name?',
      WHAT_IS_YOUR_EMAIL: 'Wie ist Ihre Email-Adresse?',
      WHAT_IS_YOUR_PHONE: 'Wie ist Ihre Telefon-Nummer?',
      WHAT_IS_YOUR_QUESTION: 'Bitte nennen Sie Ihr Anliegen'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Termin für ein Meeting vereinbaren',
      NEXT: 'weiter',
      BACK: 'zurück',
      ADD_ANOTHER_OPTION: 'weitere Option hinzufügen',
      GIVE_ALTERNATIVES: 'Bitte nennen Sie uns einige Termin-Alternativen',
      TIME_ZONE: 'In welcher Zeitzone befinden Sie sich?',
      WHAT_IS_YOUR_EMAIL: 'Wie lautet Ihre Email',
      ADD_NOTE: 'Bitte fügen Sie Ihre Anmerkungen hinzu',
      INVALID_EMAIL: 'Email ist ungültig',
      THANKS_FOR_BOOKING: 'Danke für Ihren Terminvorschlag',
      YOUR_REQUEST_WAS_SENT: 'Ihr Vorschlag wurde gesendet und wartet auf Bestätigung …',
      WELL_GET_BACK: 'Wir Senden Ihnen eine Email',
      CHOOSE_TIME: 'Wählen Sie eine Zeit',
      ENTER_EMAIL: 'Bitte geben Sie Ihre Email ein',
      OPTIONAL: 'Optional',
      WHEN_DO_YOU_WANT_TO_MEET: 'Wann möchten Sie sich mit uns treffen?',
      PICK_UP_TO_THREE: 'Bitte wählen Sie bis zu drei Termin-Optionen für dieses Meeting aus. Eine davon sollte dann zur Anwendung kommen ...',
      SEND_INVITATION: 'Senden Sie eine Einladung',
      INVITATION_FAILED: 'Ups! Ein Fehler ist aufgetreten. Bitte stellen Sie sicher, dass Ihre Terminwünsche nicht in der Vergangenheit liegen.',
      YOUR_NOTES: 'Ihre  Bemerkungen',
      YOUR_PROPOSED_TIMES: 'Ihr Terminvorschlag',
      RESCHEDULE_MEETING: 'Neuer Terminvorschlag',
      CANCEL_MEETING: 'Termin-Absage',
      DECLINE_MEETING: 'Termin-Absage',
      SURE_CANCEL: 'Sind Sie sicher, dass Sie den Termin absagen wollen?',
      YES_CANCEL: 'Ja, bitte absagen!',
      NEVER_MIND: 'Ist o. k.!',
      CANCELLED: 'Abgesagt',
      RESCHEDULED: 'Neuer Termin ',
      DECLINED: 'Abgelehnt',
      CONFIRMED: 'Bestätigt',
      ADD_TO_CALENDAR: 'Zum Kalender hinzufügen',
      REMOVE_FROM_CALENDAR: 'Vom Kalender entfernen',
      SUGGEST_NEW_TIME: 'Neuer Termin-Vorschlag',
      SET_UPTO_THREE_OPTIONS: 'You can setup up to 3 options. One will be accepted.',
      REQUEST_SENT: 'Your request was sent',
      WAITING_FOR_APPROVAL: 'Waiting for approval.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Schedule another appointment',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SELECT_MEETING_DATE_AND_TIME: 'Select date and time',
      MEETING_DETAILS: 'Meeting Details'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Im Moment sind wir online nicht verfügbar',
      LEAVE_MESSAGE: 'Bitte hinterlassen Sie eine Nachricht',
      OR: 'oder',
      SCHEDULE_A_MEETING: 'Ein Meeting planen',
      TRY_AGAIN: 'Bitte versuchen Sie es nochmals',
      CALL_SETTINGS: 'Anrufeinstellungen',
      CAMERA: 'Kamera',
      MICROPHONE: 'Mikrofon',
      SPEAKERS: 'Lautsprecher',
      CHAT: 'Chat',
      TEST: 'Test',
      VIDEO: 'Video',
      AUDIO: 'Nur Audio',
      SHARE_SCREEN: 'Bildschirm teilen',
      CONNECTING: 'Verbindung',
      RINGING: 'Klingeln',
      SWITCH_CAMERA: 'Kamera wechseln',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Auflegen',
      ON_OFF: 'Aus/Ein',
      PEER_IS_READY_PAYMENT: 'Ihr Chatpartner ist bereit, bitte veranlassen Sie die Zahlung',
      PAY_NOW: 'Pay now',
      CALL_END: 'Call End :)',
      CALL_NOW: 'Call now',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Call Ended',
      SELF_CONNECTION_CLOSED: 'Call Ended',
      CAMERA_ACCESS_PREVENTED: "We couldn't get access to the camera and/or microphone on this device. Please enable them first.",
      CAMERA_ACCESS_DIALOG_OPEN: 'Please approve the camera and microphone in order to start a video call.',
      REJECTED_CALL_MESSAGE: 'Please try again later',
      SELF_CALL_MESSAGE: "We're sorry. \\n You are trying to call yourself.",
      SWITCHING: 'Switching',
      ONLY_YOU_STREAM: 'Only you stream',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'Anwesend',
      SECONDS: 'Sekunden',
      PEOPLE_RECEIVED_CALLS_TODAY: 'Anrufe heute',
      SECURED: 'Gesichert',
      FROM: 'Von',
      IS_CALLING_YOU: 'ruft Sie an',
      OVER_A_SECURED_WEBCALL: 'Über einen gesicherten Web-Anruf',
      ACCEPT: 'Annehmen',
      DECLINE: 'Abweisen',
      CALL_REQUEST: 'Sie haben eine Anfrage',
      PAYMENT_REQUEST: 'Sie haben eine Zahlungsanfrage',
      PAY_NOW: 'Pay now',
      CANCEL: 'Abbrechen',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  ITALIAN: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Videochiamaci',
      MORE_INFO: 'Maggiori informazioni',
      TALK_TO_ME_NOW: 'Contattami adesso',
      FREE: 'GRATIS',
      MINUTES: 'Minuti',
      VIDEO_CALL: 'Videochiamata',
      SCHEDULE_A_MEETING: 'Fissa un appuntamento',
      SEND_FB_MESSAGE: 'Contattaci su Facebook',
      SEND_A_WHATSAPP: 'WhatsApp',
      PHONE_CALL: 'Chiama',
      YOUR_MESSAGE_HERE: 'Lascia qui il tuo messaggio',
      LEAVE_A_MESSAGE: 'Lascia un messaggio',
      SEND: 'Invia',
      HOW_CAN_WE_REACH_YOU: 'Come posso contattarvi?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Per potervi ricontattare, lasciateci i vostri dati',
      NAME: 'Nome',
      PHONE: 'Telefono',
      EMAIL: 'Email',
      CHAT: 'Chat',
      WEBCALL: 'Chiamata Web',
      VIDEO: 'VideoCall',
      SCHEDULE: 'Fissa un appuntamento',
      WHATSAPP: 'Whatsapp',
      MESSENGER: 'Messenger',
      MESSAGE: 'Messaggio',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Chatta con noi',
      START_CHAT: 'Start Chat',
      CONTACT: 'Contact',
      ACTION_SELECTOR_HEADER: 'Welcome!',
      TEXT_CHAT_HEADER: 'Chat',
      WEBCALL_HEADER: 'Chiamata Web',
      WHATSAPP_HEADER: 'Whatsapp',
      FB_MESSENGER_HEADER: 'Messenger',
      SCHEDULE_MEETING_HEADER: 'Fissa un appuntamento',
      PHONE_CALL_HEADER: 'Telefono',
      INFO_COLLECTOR_HEADER: 'Messaggio'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'Non siamo disponibili in questo momento',
      PLEASE_LEAVE_ME_A_MESSAGE: 'Si prega di lasciare un messaggio',
      MESSAGE_STAR: 'Messaggio*',
      YOUR_MESSAGE_HERE: 'Lascia qui il tuo messaggio',
      NAME: 'Nome',
      FIRST_NAME: 'Nome',
      LAST_NAME: 'Cognome',
      EMAIL: 'Email',
      INVALID_EMAIL: 'Email non valida',
      INVALID_PHONE_NUMBER: 'Numero di telefono non valido',
      OR: 'Oppure',
      SCHEDULE_A_MEETING: 'Fissa un appuntamento',
      SEND_FB_MESSAGE: 'Contattaci su Facebook',
      SEND_A_WHATSAPP: 'WhatsApp',
      PHONE: 'Telefono',
      PHONE_CALL: 'Chiama',
      SEND: 'Invia',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Come ti chiami?',
      WHAT_IS_YOUR_EMAIL: 'Qual è la tua email?',
      WHAT_IS_YOUR_PHONE: 'Qual è il tuo numero di telefono?',
      WHAT_IS_YOUR_QUESTION: 'Qual è la tua domanda?'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Fissa un appuntamento',
      NEXT: 'Avanti',
      BACK: 'Indietro',
      ADD_ANOTHER_OPTION: "Aggiungi un'altra opzione",
      GIVE_ALTERNATIVES: 'Fornisci alcune alternative per semplificare la pianificazione',
      TIME_ZONE: 'Time zone',
      WHAT_IS_YOUR_EMAIL: 'Qual è la tua email?',
      ADD_NOTE: 'Aggiungi una nota...',
      INVALID_EMAIL: 'Email non valida',
      THANKS_FOR_BOOKING: 'Grazie per la tua prenotazione',
      YOUR_REQUEST_WAS_SENT: 'La tua richiesta è stata inviata ed è in attesa di approvazione.',
      WELL_GET_BACK: 'Riceverai una risposta via email.',
      CHOOSE_TIME: "Scegli l'ora",
      ENTER_EMAIL: 'Inserisci la tua email',
      OPTIONAL: 'facoltativo',
      WHEN_DO_YOU_WANT_TO_MEET: "Quando vuoi fissare l'appuntamento? ",
      PICK_UP_TO_THREE: "Scegli fino a tre opzioni per questo incontro. Il tuo cliente dovrà approvare un'alternativa.",
      SEND_INVITATION: 'Invia la richiesta',
      INVITATION_FAILED: 'Oops! ... qualcosa è andato storto ... Controlla che gli orari delle riunioni non siano già passati',
      YOUR_NOTES: 'Le tue note',
      YOUR_PROPOSED_TIMES: "Orario d'incontro proposto",
      RESCHEDULE_MEETING: "Riprogramma l'appuntamento",
      CANCEL_MEETING: "Annulla l'appuntamento",
      DECLINE_MEETING: 'Rifiuta',
      SURE_CANCEL: 'Sei sicuro di voler annullare questo appuntamento?',
      YES_CANCEL: 'Sì, annulla',
      NEVER_MIND: 'Non importa',
      CANCELLED: 'Annullato',
      RESCHEDULED: 'Riprogrammato',
      DECLINED: 'Rifiutato',
      CONFIRMED: 'Confermato',
      ADD_TO_CALENDAR: 'Aggiungi al calendario',
      REMOVE_FROM_CALENDAR: 'Rimuovi dal calendario',
      SUGGEST_NEW_TIME: "Suggerisci un nuovo orario per l'incontro",
      SET_UPTO_THREE_OPTIONS: 'You can setup up to 3 options. One will be accepted.',
      REQUEST_SENT: 'Your request was sent',
      WAITING_FOR_APPROVAL: 'Waiting for approval.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Schedule another appointment',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SELECT_MEETING_DATE_AND_TIME: 'Select date and time',
      MEETING_DETAILS: 'Meeting Details'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Ciao, non siamo disponibile al momento.',
      LEAVE_MESSAGE: 'Lasciateci un messaggio',
      OR: 'o',
      SCHEDULE_A_MEETING: "Fissate un'appuntamento",
      TRY_AGAIN: 'Riprova',
      CALL_SETTINGS: 'Impostazioni di chiamata',
      CAMERA: 'Camera',
      MICROPHONE: 'Microfono',
      SPEAKERS: 'Altoparlanti',
      CHAT: 'Chat',
      TEST: 'Test',
      VIDEO: 'Video',
      AUDIO: 'Solo audio',
      SHARE_SCREEN: 'Condividi schermo',
      CONNECTING: 'Collegamento',
      RINGING: 'Ringing',
      SWITCH_CAMERA: 'Cambia fotocamera',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Riaggancia',
      ON_OFF: 'Camera Off/On',
      PEER_IS_READY_PAYMENT: 'Your peer is ready. Please start payment',
      PAY_NOW: 'Paga adesso',
      CALL_END: 'Chiamata terminata  :)',
      CALL_NOW: 'Call now',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Call Ended',
      SELF_CONNECTION_CLOSED: 'Call Ended',
      CAMERA_ACCESS_PREVENTED: "We couldn't get access to the camera and/or microphone on this device. Please enable them first.",
      CAMERA_ACCESS_DIALOG_OPEN: 'Please approve the camera and microphone in order to start a video call.',
      REJECTED_CALL_MESSAGE: 'Please try again later',
      SELF_CALL_MESSAGE: "We're sorry. \\n You are trying to call yourself.",
      SWITCHING: 'Switching',
      ONLY_YOU_STREAM: 'Only you stream',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'In linea',
      SECONDS: 'Secondi',
      PEOPLE_RECEIVED_CALLS_TODAY: 'Chiamate ricevute oggi',
      SECURED: 'Sicuro',
      FROM: 'Da',
      IS_CALLING_YOU: 'Chiamata in corso',
      OVER_A_SECURED_WEBCALL: '',
      ACCEPT: 'Accetta',
      DECLINE: 'Rifiuta',
      CALL_REQUEST: 'Hai una richiesta di chiamata',
      PAYMENT_REQUEST: 'Hai una richiesta di pagamento',
      PAY_NOW: 'Paga adesso',
      CANCEL: 'Cancella',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  RUSSIAN: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Поговорим?',
      MORE_INFO: 'Дополнительная информация',
      TALK_TO_ME_NOW: 'Свяжитесь с нами сейчас',
      FREE: 'Бесплатно',
      MINUTES: 'Минуты',
      VIDEO_CALL: 'Видео звонок',
      SCHEDULE_A_MEETING: 'Запрос на встречу',
      SEND_FB_MESSAGE: 'Написать в Facebook',
      SEND_A_WHATSAPP: 'Написать в WhatsApp',
      PHONE_CALL: 'Звонок',
      YOUR_MESSAGE_HERE: 'Ваше сообщение',
      LEAVE_A_MESSAGE: 'Оставить сообщение',
      SEND: 'Отправить',
      HOW_CAN_WE_REACH_YOU: 'Как можно с вами связаться?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Оставьте контактные данные',
      NAME: 'Имя',
      PHONE: 'Телефон',
      EMAIL: 'Электронная почта',
      CHAT: 'Чат',
      WEBCALL: 'Онлайн звонок',
      VIDEO: 'Видео',
      SCHEDULE: 'Бронирование встречи',
      WHATSAPP: 'WhatsApp',
      MESSENGER: 'Facebook Messenger',
      MESSAGE: 'Сообщение',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Скажите что-нибудь',
      START_CHAT: 'Start Chat',
      CONTACT: 'Contact',
      ACTION_SELECTOR_HEADER: 'Welcome!',
      TEXT_CHAT_HEADER: 'Чат',
      WEBCALL_HEADER: 'Онлайн звонок',
      WHATSAPP_HEADER: 'WhatsApp',
      FB_MESSENGER_HEADER: 'Facebook Messenger',
      SCHEDULE_MEETING_HEADER: 'Запрос на встречу',
      PHONE_CALL_HEADER: 'Телефон',
      INFO_COLLECTOR_HEADER: 'Сообщение'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'В данный момент у меня нет возможности ответить вам',
      PLEASE_LEAVE_ME_A_MESSAGE: 'Пожалуйста, оставьте сообщение',
      MESSAGE_STAR: 'Сообщение*',
      YOUR_MESSAGE_HERE: 'Ваше сообщение',
      NAME: 'Ваше имя',
      FIRST_NAME: 'Имя',
      LAST_NAME: 'Фамилия',
      EMAIL: 'Электронная почта',
      INVALID_EMAIL: 'Неправильный формат эл. почты',
      INVALID_PHONE_NUMBER: 'Неправильный номер телефона',
      OR: 'ИЛИ',
      SCHEDULE_A_MEETING: 'Забронировать встречу',
      SEND_FB_MESSAGE: 'Facebook',
      SEND_A_WHATSAPP: 'WhatsApp',
      PHONE: 'Телефон',
      PHONE_CALL: 'Звонок',
      SEND: 'Отправить',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Ваше имя',
      WHAT_IS_YOUR_EMAIL: 'Ваша эл. почта',
      WHAT_IS_YOUR_PHONE: 'Ваш номер телефона',
      WHAT_IS_YOUR_QUESTION: 'Ваш вопрос'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Давайте запланируем нашу встречу',
      NEXT: 'Вперед',
      BACK: 'Назад',
      ADD_ANOTHER_OPTION: 'Добавить еще одну опцию',
      GIVE_ALTERNATIVES: 'Укажите несколько вариантов, чтобы бронирование встречи прошло гладко',
      TIME_ZONE: 'Часовой пояс',
      WHAT_IS_YOUR_EMAIL: 'Ваша эл. почта',
      ADD_NOTE: 'Добавить заметку...',
      INVALID_EMAIL: 'Неправильно указанная почта',
      THANKS_FOR_BOOKING: 'Благодарим за бронирование',
      YOUR_REQUEST_WAS_SENT: 'Ваш запрос на встречу был отправлен и будет рассмотрен в ближайшее время',
      WELL_GET_BACK: 'Мы свяжемся с вами по почте',
      CHOOSE_TIME: 'Выберите время',
      ENTER_EMAIL: 'Введите вашу почту',
      OPTIONAL: 'Опционально',
      WHEN_DO_YOU_WANT_TO_MEET: 'Когда вам удобно встретиться?',
      PICK_UP_TO_THREE: 'Выберите три опции для этой встречи. Ваш клиент должен будет подтвердить одну из них',
      SEND_INVITATION: 'Отправить приглашение',
      INVITATION_FAILED: 'Что-то пошло не так. Пожалуйста, проверьте, что время встречи указано в будущем',
      YOUR_NOTES: 'Ваши заметки',
      YOUR_PROPOSED_TIMES: 'Ваше время встречи',
      RESCHEDULE_MEETING: 'Перенести встречу',
      CANCEL_MEETING: 'Отменить встречу',
      DECLINE_MEETING: 'Отклонить',
      SURE_CANCEL: 'Вы уверены, что хотите отменить эту встречу?',
      YES_CANCEL: 'Да, отменить',
      NEVER_MIND: 'Нет',
      CANCELLED: 'Отменено',
      RESCHEDULED: 'Перенесено',
      DECLINED: 'Отклонено',
      CONFIRMED: 'Подтверждено',
      ADD_TO_CALENDAR: 'Добавить в календарь',
      REMOVE_FROM_CALENDAR: 'Убрать из календаря',
      SUGGEST_NEW_TIME: 'Предложить другое время для встречи',
      SET_UPTO_THREE_OPTIONS: 'You can setup up to 3 options. One will be accepted.',
      REQUEST_SENT: 'Your request was sent',
      WAITING_FOR_APPROVAL: 'Waiting for approval.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Schedule another appointment',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SELECT_MEETING_DATE_AND_TIME: 'Select date and time',
      MEETING_DETAILS: 'Meeting Details'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Здравствуйте. Я сейчас недоступен.',
      LEAVE_MESSAGE: 'Оставьте сообщение',
      OR: 'или',
      SCHEDULE_A_MEETING: 'Заказать звонок',
      TRY_AGAIN: 'Попробовать снова',
      CALL_SETTINGS: 'Настройки звонка',
      CAMERA: 'Камера',
      MICROPHONE: 'Микрофон',
      SPEAKERS: 'Звук',
      CHAT: 'Chat',
      TEST: 'Тест',
      VIDEO: 'Видео',
      AUDIO: 'Только аудио',
      SHARE_SCREEN: 'Поделиться экраном',
      CONNECTING: 'Соединяемся',
      RINGING: 'Звоним',
      SWITCH_CAMERA: 'Переключить камеру',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Повесить трубку',
      ON_OFF: 'Вкл/выкл',
      PEER_IS_READY_PAYMENT: 'Ваш собеседник готов. Внесите оплату',
      PAY_NOW: 'Оплатить',
      CALL_END: 'Конец звонка:)',
      CALL_NOW: 'Call now',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Call Ended',
      SELF_CONNECTION_CLOSED: 'Call Ended',
      CAMERA_ACCESS_PREVENTED: "We couldn't get access to the camera and/or microphone on this device. Please enable them first.",
      CAMERA_ACCESS_DIALOG_OPEN: 'Please approve the camera and microphone in order to start a video call.',
      REJECTED_CALL_MESSAGE: 'Please try again later',
      SELF_CALL_MESSAGE: "We're sorry. \\n You are trying to call yourself.",
      SWITCHING: 'Switching',
      ONLY_YOU_STREAM: 'Only you stream',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'Через',
      SECONDS: ' ',
      PEOPLE_RECEIVED_CALLS_TODAY: 'Человек получили сегодня звонок',
      SECURED: 'защищенный',
      FROM: 'из',
      IS_CALLING_YOU: 'звонит вам',
      OVER_A_SECURED_WEBCALL: 'через защищенный веб-звонок',
      ACCEPT: 'Принять',
      DECLINE: 'Отклонить',
      CALL_REQUEST: 'У вас запрос на обратный звонок',
      PAYMENT_REQUEST: 'У вас запрос на оплату',
      PAY_NOW: 'Оплатить',
      CANCEL: 'Отмена',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  DUTCH: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Zullen we praten',
      MORE_INFO: 'Meer informatie',
      TALK_TO_ME_NOW: 'Spreek nu met me',
      FREE: 'GRATIS!!',
      MINUTES: 'Minuten',
      VIDEO_CALL: 'Video Oproep',
      SCHEDULE_A_MEETING: 'Een vergadering inplannen',
      SEND_FB_MESSAGE: 'Verzend Facebook bericht',
      SEND_A_WHATSAPP: 'Verzend Whatsapp bericht',
      PHONE_CALL: 'Telefoongesprek',
      YOUR_MESSAGE_HERE: 'Jouw bericht',
      LEAVE_A_MESSAGE: 'Laat een bericht achter',
      SEND: 'Versturen',
      HOW_CAN_WE_REACH_YOU: 'Hoe kunnen we jouw bereiken?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Laat je gegevens achter zodat we contact kunnen opnemen',
      NAME: 'Naam',
      PHONE: 'Telefoonnummer',
      EMAIL: 'Email',
      CHAT: 'Chat',
      WEBCALL: 'Webcall',
      VIDEO: 'Video',
      SCHEDULE: 'Agenda',
      WHATSAPP: 'Whatsapp',
      MESSENGER: 'Messenger',
      MESSAGE: 'Bericht',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Say something',
      START_CHAT: 'Start Chat',
      CONTACT: 'Contact',
      ACTION_SELECTOR_HEADER: 'Welcome!',
      TEXT_CHAT_HEADER: 'Chat',
      WEBCALL_HEADER: 'Webcall',
      WHATSAPP_HEADER: 'Whatsapp',
      FB_MESSENGER_HEADER: 'Messenger',
      SCHEDULE_MEETING_HEADER: 'Een vergadering inplannen',
      PHONE_CALL_HEADER: 'Telefoonnummer',
      INFO_COLLECTOR_HEADER: 'Bericht'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'Ik ben niet beschikbaar',
      PLEASE_LEAVE_ME_A_MESSAGE: 'Laat een bericht achter',
      MESSAGE_STAR: 'Bericht*',
      YOUR_MESSAGE_HERE: 'Jouw bericht hier',
      NAME: 'Naam',
      FIRST_NAME: 'Voornaam',
      LAST_NAME: 'Achternaam',
      EMAIL: 'Email',
      INVALID_EMAIL: 'Ongeldig Email adres',
      INVALID_PHONE_NUMBER: 'Invalid phone number',
      OR: 'of',
      SCHEDULE_A_MEETING: 'Een vergadering plannen',
      SEND_FB_MESSAGE: 'Stuur Facebook bericht',
      SEND_A_WHATSAPP: 'Stuur Whatsapp bericht',
      PHONE: 'Telefoonnummer',
      PHONE_CALL: 'Telefoongesprek',
      SEND: 'Versturen',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Wat is jouw naam?',
      WHAT_IS_YOUR_EMAIL: 'Wat is jouw Emal?',
      WHAT_IS_YOUR_PHONE: 'Wat is jouw telefoonnummer',
      WHAT_IS_YOUR_QUESTION: 'Wat is jouw vraag?'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Zullen we een afspraak maken',
      NEXT: 'Volgende',
      BACK: 'Vorige',
      ADD_ANOTHER_OPTION: 'Voeg een optie toe',
      GIVE_ALTERNATIVES: 'Geef je idee over hoe het afspaken maken eenvoudiger kan',
      TIME_ZONE: 'Tijd zone',
      WHAT_IS_YOUR_EMAIL: 'Wat is je Email?',
      ADD_NOTE: 'Opmerking toevoegen',
      INVALID_EMAIL: 'Ongeldig Email adres',
      THANKS_FOR_BOOKING: 'Bedankt voor de boeking',
      YOUR_REQUEST_WAS_SENT: 'Je afspraak is verzonden en wacht op bevestiging',
      WELL_GET_BACK: 'Je kunt van ons een Email verwachten',
      CHOOSE_TIME: 'Kies tijd',
      ENTER_EMAIL: 'Voer Email in',
      OPTIONAL: 'Optioneel',
      WHEN_DO_YOU_WANT_TO_MEET: 'Wanneer wil je afspreken?',
      PICK_UP_TO_THREE: 'Pick up to three options for this meeting. Your client will need to approve one alternative',
      SEND_INVITATION: 'Verstuur Uitnodiging',
      INVITATION_FAILED: 'Oh…Er is iets misgegaan… Check of de afspraak niet in het verleden ligt',
      YOUR_NOTES: 'Aantekeningen',
      YOUR_PROPOSED_TIMES: 'Jouw voorgestelde afspraak',
      RESCHEDULE_MEETING: 'Afspraak verplaatsen',
      CANCEL_MEETING: 'Afspraak afzeggen',
      DECLINE_MEETING: 'Afspraak weigeren',
      SURE_CANCEL: 'Weet je het zeker dat je de afspraak wilt afzeggen?',
      YES_CANCEL: 'Ja, afzeggen',
      NEVER_MIND: 'Geen probleem',
      CANCELLED: 'Geannuleerd',
      RESCHEDULED: 'Gwijzigfd',
      DECLINED: 'Afgewezen',
      CONFIRMED: 'Bevestigd',
      ADD_TO_CALENDAR: 'Voeg aan agenda toe',
      REMOVE_FROM_CALENDAR: 'Verwijder uit agenda',
      SUGGEST_NEW_TIME: 'Voorstel nieuw tijdstop',
      SET_UPTO_THREE_OPTIONS: 'You can setup up to 3 options. One will be accepted.',
      REQUEST_SENT: 'Your request was sent',
      WAITING_FOR_APPROVAL: 'Waiting for approval.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Schedule another appointment',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SELECT_MEETING_DATE_AND_TIME: 'Select date and time',
      MEETING_DETAILS: 'Meeting Details'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Ik ben niet beschikbaar',
      LEAVE_MESSAGE: 'Laat een bericht achter',
      OR: 'of',
      SCHEDULE_A_MEETING: 'Een vergadering plannen',
      TRY_AGAIN: 'Probeer het opnieuw',
      CALL_SETTINGS: 'Bel instellingen',
      CAMERA: 'Camera',
      MICROPHONE: 'Microfoon',
      SPEAKERS: 'Luidsprekers',
      CHAT: 'Chat',
      TEST: 'Test',
      VIDEO: 'Video',
      AUDIO: 'Audio',
      SHARE_SCREEN: 'Scherm delen',
      CONNECTING: 'Verbinden',
      RINGING: 'Rinkelen',
      SWITCH_CAMERA: 'Switch camera',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Hangup',
      ON_OFF: 'Off/On',
      PEER_IS_READY_PAYMENT: 'Your peer is ready. Please start payment',
      PAY_NOW: 'Pay now',
      CALL_END: 'Call End :)',
      CALL_NOW: 'Call now',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Call Ended',
      SELF_CONNECTION_CLOSED: 'Call Ended',
      CAMERA_ACCESS_PREVENTED: "We couldn't get access to the camera and/or microphone on this device. Please enable them first.",
      CAMERA_ACCESS_DIALOG_OPEN: 'Please approve the camera and microphone in order to start a video call.',
      REJECTED_CALL_MESSAGE: 'Please try again later',
      SELF_CALL_MESSAGE: "We're sorry. \\n You are trying to call yourself.",
      SWITCHING: 'Switching',
      ONLY_YOU_STREAM: 'Only you stream',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'In',
      SECONDS: 'Seconds',
      PEOPLE_RECEIVED_CALLS_TODAY: 'People received calls today',
      SECURED: 'Secured',
      FROM: 'From',
      IS_CALLING_YOU: 'is calling you',
      OVER_A_SECURED_WEBCALL: 'over a secured web call',
      ACCEPT: 'Accept',
      DECLINE: 'Decline',
      CALL_REQUEST: 'You have a call request',
      PAYMENT_REQUEST: 'You have a payment request',
      PAY_NOW: 'Pay now',
      CANCEL: 'Cancel',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  GREEK: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Ας μιλήσουμε',
      MORE_INFO: 'Περισσότερες πληροφορίες',
      TALK_TO_ME_NOW: 'Μίλησέ μου',
      FREE: 'ΔΩΡΕΑΝ!',
      MINUTES: 'Λεπτά',
      VIDEO_CALL: 'Bιντεοκλήση',
      SCHEDULE_A_MEETING: 'Προγραμματίστε μια συνάντηση',
      SEND_FB_MESSAGE: 'Αποστολή μηνύματος FB',
      SEND_A_WHATSAPP: 'Αποστολή μηνύματος WhatsApp',
      PHONE_CALL: 'Κλήση',
      YOUR_MESSAGE_HERE: 'Αφήστε το μήνυμά σας εδώ',
      LEAVE_A_MESSAGE: 'Αφήστε ένα μήνυμα',
      SEND: 'Αποστολή',
      HOW_CAN_WE_REACH_YOU: 'Πώς μπορούμε να επικοινωνήσουμε μαζί σας;',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Για να επικοινωνήσουμε μαζί σας παρακαλούμε αφήστε τα στοιχεία σας',
      NAME: 'Όνομα',
      PHONE: 'Τηλέφωνο',
      EMAIL: 'Email',
      CHAT: 'Συνομιλία',
      WEBCALL: 'Διαδικτυακή κλήση',
      VIDEO: 'Βίντεο',
      SCHEDULE: 'Πρόγραμμα',
      WHATSAPP: 'Whatsapp',
      MESSENGER: 'FB Messenger',
      MESSAGE: 'Μήνυμα',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Πείτε κάτι',
      START_CHAT: 'Start Chat',
      CONTACT: 'Contact',
      ACTION_SELECTOR_HEADER: 'Welcome!',
      TEXT_CHAT_HEADER: 'Συνομιλία',
      WEBCALL_HEADER: 'Διαδικτυακή κλήση',
      WHATSAPP_HEADER: 'Whatsapp',
      FB_MESSENGER_HEADER: 'FB Messenger',
      SCHEDULE_MEETING_HEADER: 'Προγραμματίστε μια συνάντηση',
      PHONE_CALL_HEADER: 'Τηλέφωνο',
      INFO_COLLECTOR_HEADER: 'Μήνυμα'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'Δεν είμαι διαθέσιμος αυτή τη στιγμή',
      PLEASE_LEAVE_ME_A_MESSAGE: 'Παρακαλώ αφήστε μου μήνυμα',
      MESSAGE_STAR: 'Μήνυμα*',
      YOUR_MESSAGE_HERE: 'Το μήνυμά σας εδώ',
      NAME: 'Όνομα',
      FIRST_NAME: 'Όνομα',
      LAST_NAME: 'Επίθετο',
      EMAIL: 'Email',
      INVALID_EMAIL: 'Μη έγκυρο email',
      INVALID_PHONE_NUMBER: 'Μη έγκυρο τηλέφωνο',
      OR: 'ή',
      SCHEDULE_A_MEETING: 'Προγραμματίστε μια συνάντηση',
      SEND_FB_MESSAGE: 'Αποστολή μηνύματος Facebook',
      SEND_A_WHATSAPP: 'Αποστολή μηνύματος WhatsApp',
      PHONE: 'Τηλέφωνο',
      PHONE_CALL: 'Κλήση',
      SEND: 'Αποστολή',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Ποιο είναι το όνομά σας;',
      WHAT_IS_YOUR_EMAIL: 'Ποιο είναι το email σας;',
      WHAT_IS_YOUR_PHONE: 'Ποιο είναι το τηλέφωνό σας;',
      WHAT_IS_YOUR_QUESTION: 'Ποια είναι η ερώτησή σας;'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Ας προγραμματίσουμε τη συνάντησή μας',
      NEXT: 'Επόμενο',
      BACK: 'Προηγούμενο',
      ADD_ANOTHER_OPTION: 'Προσθέστε μια επιλογή',
      GIVE_ALTERNATIVES: 'Δώστε μερικές εναλλακτικές λύσεις για να διευκολύνετε τη ροή του προγραμματισμού',
      TIME_ZONE: 'Ζώνη ώρας',
      WHAT_IS_YOUR_EMAIL: 'Ποιο είναι το email σας;',
      ADD_NOTE: 'Προσθέστε μια σημείωση',
      INVALID_EMAIL: 'Μη έγκυρο email',
      THANKS_FOR_BOOKING: 'Ευχαριστούμε για την κράτησή σας',
      YOUR_REQUEST_WAS_SENT: 'Το αίτημα για συνάντηση μαζί σας έχει σταλεί και περιμένει έγκριση.',
      WELL_GET_BACK: 'Θα επικοινωνήσουμε μαζί σας μέσω email.',
      CHOOSE_TIME: 'Επιλέξτε ώρα',
      ENTER_EMAIL: 'Συμπληρώστε το email σας',
      OPTIONAL: 'Προαιρετικό',
      WHEN_DO_YOU_WANT_TO_MEET: 'Πότε θα θέλατε να κανονίζαμε τη συνάντηση;',
      PICK_UP_TO_THREE: 'Διαλέξτε τρεις επιλογές για αυτή τη συνάντηση. Ο πελάτης σας θα χρειαστεί να εγκρίνει μια εναλλακτική λύση',
      SEND_INVITATION: 'Αποστολή Πρόσκλησης',
      INVITATION_FAILED: 'Ωχ ... κάτι πήγε στραβά ... Ελέγξτε ότι οι χρόνοι συνάντησης δεν ήταν στο παρελθόν',
      YOUR_NOTES: 'Οι σημειώσεις σας',
      YOUR_PROPOSED_TIMES: 'Η προτεινόμενη ώρα συνάντησής σας',
      RESCHEDULE_MEETING: 'Επαναπρογραμματισμός συνάντησης',
      CANCEL_MEETING: 'Ακύρωση συνάντησης',
      DECLINE_MEETING: 'Απόρριψη',
      SURE_CANCEL: 'Είστε βέβαιοι ότι θέλετε να ακυρώσετε αυτό το ραντεβού;',
      YES_CANCEL: 'Ναι, Ακύρωση',
      NEVER_MIND: 'Δε πειράζει',
      CANCELLED: 'Ακυρώθηκε',
      RESCHEDULED: 'Επαναπρογραμματίστηκε',
      DECLINED: 'Απορρίφθηκε',
      CONFIRMED: 'Επιβεβαιώθηκε',
      ADD_TO_CALENDAR: 'Προσθήκη στο ημερολόγιο',
      REMOVE_FROM_CALENDAR: 'Κατάργηση από το ημερολόγιο',
      SUGGEST_NEW_TIME: 'Προτείνετε νέα ώρα για συνάντηση',
      SET_UPTO_THREE_OPTIONS: 'You can setup up to 3 options. One will be accepted.',
      REQUEST_SENT: 'Your request was sent',
      WAITING_FOR_APPROVAL: 'Waiting for approval.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Schedule another appointment',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SELECT_MEETING_DATE_AND_TIME: 'Select date and time',
      MEETING_DETAILS: 'Meeting Details'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Γεια σας, δεν είμαι διαθέσιμος τώρα.',
      LEAVE_MESSAGE: 'Αφήστε μου ένα μήνυμα',
      OR: 'ή',
      SCHEDULE_A_MEETING: 'Προγραμματίστε μια συνάντηση.',
      TRY_AGAIN: 'Δοκιμάστε ξανά',
      CALL_SETTINGS: 'Ρυθμίσεις κλήσεων',
      CAMERA: 'Κάμερα',
      MICROPHONE: 'Μικρόφωνο',
      SPEAKERS: 'Ηχεία',
      CHAT: 'Chat',
      TEST: 'Τεστ',
      VIDEO: 'Βίντεο',
      AUDIO: 'Μόνο ήχος',
      SHARE_SCREEN: 'Κοινή προβολή οθόνης',
      CONNECTING: 'Σύνδεση',
      RINGING: 'Κλήση',
      SWITCH_CAMERA: 'Αλλαγή κάμερας',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Κλείσιμο',
      ON_OFF: 'Κλειστό/Ανοιχτό',
      PEER_IS_READY_PAYMENT: 'Your peer is ready. Please start payment',
      PAY_NOW: 'Pay now',
      CALL_END: 'Τέλος κλήσης  :)',
      CALL_NOW: 'Call now',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Call Ended',
      SELF_CONNECTION_CLOSED: 'Call Ended',
      CAMERA_ACCESS_PREVENTED: "We couldn't get access to the camera and/or microphone on this device. Please enable them first.",
      CAMERA_ACCESS_DIALOG_OPEN: 'Please approve the camera and microphone in order to start a video call.',
      REJECTED_CALL_MESSAGE: 'Please try again later',
      SELF_CALL_MESSAGE: "We're sorry. \\n You are trying to call yourself.",
      SWITCHING: 'Switching',
      ONLY_YOU_STREAM: 'Only you stream',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'Σε',
      SECONDS: 'Δευτερόλεπτα',
      PEOPLE_RECEIVED_CALLS_TODAY: 'άνθρωποι έλαβαν κλήσεις σήμερα',
      SECURED: 'Ασφαλής',
      FROM: 'από',
      IS_CALLING_YOU: 'σας καλεί',
      OVER_A_SECURED_WEBCALL: 'μέσω μιας ασφαλούς διαδικτυακής κλήσης',
      ACCEPT: 'Αποδοχή',
      DECLINE: 'Απόρριψη',
      CALL_REQUEST: 'You have a call request',
      PAYMENT_REQUEST: 'You have a payment request',
      PAY_NOW: 'Pay now',
      CANCEL: 'Cancel',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  CROATIAN: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Razgovarajmo',
      MORE_INFO: 'Više informacija',
      TALK_TO_ME_NOW: 'Započni razgovor',
      FREE: 'BESPLATNO!',
      MINUTES: 'Minute',
      VIDEO_CALL: 'Video poziv',
      SCHEDULE_A_MEETING: 'Dogovori sastanak',
      SEND_FB_MESSAGE: 'Pošalji Facebook poruku',
      SEND_A_WHATSAPP: 'Pošalji Whatsapp poruku',
      PHONE_CALL: 'Poziv',
      YOUR_MESSAGE_HERE: 'Upišite poruku ovdje',
      LEAVE_A_MESSAGE: 'Ostavi poruku',
      SEND: 'Pošalji',
      HOW_CAN_WE_REACH_YOU: 'Kako Vas možemo kontaktirati',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Molimo ostavite svoje kontakt podatke kako bismo Vam se mogli povratno javiti',
      NAME: 'Ime',
      PHONE: 'Broj mobitela',
      EMAIL: 'E-mail',
      CHAT: 'Chat',
      WEBCALL: 'Poziv',
      VIDEO: 'Video',
      SCHEDULE: 'Raspored',
      WHATSAPP: 'Whatsapp',
      MESSENGER: 'Facebook Messenger',
      MESSAGE: 'Poruka',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Reci nešto',
      START_CHAT: 'Start Chat',
      CONTACT: 'Contact',
      ACTION_SELECTOR_HEADER: 'Welcome!',
      TEXT_CHAT_HEADER: 'Chat',
      WEBCALL_HEADER: 'Poziv',
      WHATSAPP_HEADER: 'Whatsapp',
      FB_MESSENGER_HEADER: 'Facebook Messenger',
      SCHEDULE_MEETING_HEADER: 'Dogovori sastanak',
      PHONE_CALL_HEADER: 'Broj mobitela',
      INFO_COLLECTOR_HEADER: 'Poruka'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'Trenutno nisam dostupan',
      PLEASE_LEAVE_ME_A_MESSAGE: 'Molimo ostavite poruku',
      MESSAGE_STAR: 'Poruka*',
      YOUR_MESSAGE_HERE: 'Vaša poruka ovdje',
      NAME: 'Ime',
      FIRST_NAME: 'Ime',
      LAST_NAME: 'Prezime',
      EMAIL: 'E-mail',
      INVALID_EMAIL: 'Pogrešan e-mail',
      INVALID_PHONE_NUMBER: 'Pogrešan broj mobitela',
      OR: 'ili',
      SCHEDULE_A_MEETING: 'Dogovori sastanak',
      SEND_FB_MESSAGE: 'Pošalji Facebook poruku',
      SEND_A_WHATSAPP: 'Pošalji Whatsapp poruku',
      PHONE: 'Mobitel',
      PHONE_CALL: 'Poziv',
      SEND: 'Pošalji',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Koje je Vaše ime?',
      WHAT_IS_YOUR_EMAIL: 'Koji je Vaš e-mail?',
      WHAT_IS_YOUR_PHONE: 'Koji je broj Vašeg mobitela?',
      WHAT_IS_YOUR_QUESTION: 'Vaše pitanje?'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Dogovorimo sastanak',
      NEXT: 'Sljedeće',
      BACK: 'Natrag',
      ADD_ANOTHER_OPTION: 'Dodaj opciju',
      GIVE_ALTERNATIVES: 'Predložite alternativne termine kako biste olakšali dogovaranje sastanka',
      TIME_ZONE: 'Vremenska zona',
      WHAT_IS_YOUR_EMAIL: 'Koji je Vaš e-mail?',
      ADD_NOTE: 'Dodaj bilješku',
      INVALID_EMAIL: 'Pogrešan e-mail',
      THANKS_FOR_BOOKING: 'Hvala na rezervaciji termina',
      YOUR_REQUEST_WAS_SENT: 'Vaš zahtjev za sastankom je poslan te čeka na odobrenje.',
      WELL_GET_BACK: 'Javiti ćemo Vam se povratno putem e-maila.',
      CHOOSE_TIME: 'Izaberi vrijeme',
      ENTER_EMAIL: 'Unesite svoj e-mail',
      OPTIONAL: 'Opcionalno',
      WHEN_DO_YOU_WANT_TO_MEET: 'Kada želite sastanak?',
      PICK_UP_TO_THREE: 'Izaberite do tri opcije za ovaj sastanak. Klijent će morati odobriti jednu od opcija',
      SEND_INVITATION: 'Pošalji pozivnicu',
      INVITATION_FAILED: 'Nešto je krivo. Molimo provjerite da vremena koja ste izabrali nisu u prošlosti.',
      YOUR_NOTES: 'Vaše bilješke',
      YOUR_PROPOSED_TIMES: 'Vaši predloženi termini sastanka',
      RESCHEDULE_MEETING: 'Promjeni termin sastanka',
      CANCEL_MEETING: 'Otkaži sastanak',
      DECLINE_MEETING: 'Odbij sastanak',
      SURE_CANCEL: 'Jeste li sigurni da želite otkazati ovaj sastanak?',
      YES_CANCEL: 'Da, otkaži',
      NEVER_MIND: 'Nema veze',
      CANCELLED: 'Otkazano',
      RESCHEDULED: 'Promijenjen termin',
      DECLINED: 'Odbijeno',
      CONFIRMED: 'Potvrđeno',
      ADD_TO_CALENDAR: 'Dodaj u kalendar',
      REMOVE_FROM_CALENDAR: 'Makni iz kalendara',
      SUGGEST_NEW_TIME: 'Predloži novo vrijeme sastanka',
      SET_UPTO_THREE_OPTIONS: 'You can setup up to 3 options. One will be accepted.',
      REQUEST_SENT: 'Your request was sent',
      WAITING_FOR_APPROVAL: 'Waiting for approval.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Schedule another appointment',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SELECT_MEETING_DATE_AND_TIME: 'Select date and time',
      MEETING_DETAILS: 'Meeting Details'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Pozdrav, trenutno nismo dostupni.',
      LEAVE_MESSAGE: 'Ostavite poruku',
      OR: 'ili',
      SCHEDULE_A_MEETING: 'dogovorite sastanak',
      TRY_AGAIN: 'Pokušaj ponovno',
      CALL_SETTINGS: 'Postavke poziva',
      CAMERA: 'Kamera',
      MICROPHONE: 'Mikrofon',
      SPEAKERS: 'Zvučnici',
      CHAT: 'Chat',
      TEST: 'Test',
      VIDEO: 'Video',
      AUDIO: 'Samo zvuk',
      SHARE_SCREEN: 'Dijeli ekran',
      CONNECTING: 'Spajanje',
      RINGING: 'Zvoni',
      SWITCH_CAMERA: 'Promjeni kameru',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Poklopi',
      ON_OFF: 'Isklj./Uklj.',
      PEER_IS_READY_PAYMENT: 'Vaš sugovornik je spreman. Molimo započnite plaćanje',
      PAY_NOW: 'Plati sada',
      CALL_END: 'Kraj razgovora :)',
      CALL_NOW: 'Call now',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Call Ended',
      SELF_CONNECTION_CLOSED: 'Call Ended',
      CAMERA_ACCESS_PREVENTED: "We couldn't get access to the camera and/or microphone on this device. Please enable them first.",
      CAMERA_ACCESS_DIALOG_OPEN: 'Please approve the camera and microphone in order to start a video call.',
      REJECTED_CALL_MESSAGE: 'Please try again later',
      SELF_CALL_MESSAGE: "We're sorry. \\n You are trying to call yourself.",
      SWITCHING: 'Switching',
      ONLY_YOU_STREAM: 'Only you stream',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'Za',
      SECONDS: 'Sekundi',
      PEOPLE_RECEIVED_CALLS_TODAY: 'Ljudi primilo poziv danas',
      SECURED: 'Osigurano',
      FROM: 'Od',
      IS_CALLING_YOU: 'te zove',
      OVER_A_SECURED_WEBCALL: 'putem sigurnog internet poziva',
      ACCEPT: 'Prihvati',
      DECLINE: 'Odbij',
      CALL_REQUEST: 'Imate zahtjev za pozivom',
      PAYMENT_REQUEST: 'Imate zahtjev za plaćanjem',
      PAY_NOW: 'Plati sada',
      CANCEL: 'Otkaži',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  POLISH: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Porozmawiajmy',
      MORE_INFO: 'więcej informacji',
      TALK_TO_ME_NOW: 'Teraz mów do mnie',
      FREE: 'GRATIS!!',
      MINUTES: 'Minuty',
      VIDEO_CALL: 'Połączenie wideo',
      SCHEDULE_A_MEETING: 'Umów spotkanie',
      SEND_FB_MESSAGE: 'Wyślij wiadomość przez messengera',
      SEND_A_WHATSAPP: 'Wyślij wiadomość przez Whatsapp',
      PHONE_CALL: 'Zadzwoń',
      YOUR_MESSAGE_HERE: 'Twoja wiadomość',
      LEAVE_A_MESSAGE: 'Zostaw wiadomość',
      SEND: 'Wyślij',
      HOW_CAN_WE_REACH_YOU: 'Jak możemy się z Tobą skontaktować?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Aby się z Tobą skontaktować, zostaw swoje dane',
      NAME: 'Imię',
      PHONE: 'Telefon',
      EMAIL: 'Email',
      CHAT: 'Czat',
      WEBCALL: 'Połączenie przez internet',
      VIDEO: 'Wideo',
      SCHEDULE: 'Harmonogram',
      WHATSAPP: 'Whatsapp',
      MESSENGER: 'Messenger',
      MESSAGE: 'Wiadomość',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Powiedz coś',
      START_CHAT: 'Start Chat',
      CONTACT: 'Contact',
      ACTION_SELECTOR_HEADER: 'Welcome!',
      TEXT_CHAT_HEADER: 'Czat',
      WEBCALL_HEADER: 'Połączenie przez internet',
      WHATSAPP_HEADER: 'Whatsapp',
      FB_MESSENGER_HEADER: 'Messenger',
      SCHEDULE_MEETING_HEADER: 'Umów spotkanie',
      PHONE_CALL_HEADER: 'Telefon',
      INFO_COLLECTOR_HEADER: 'Wiadomość'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'Jestem teraz niedostępny',
      PLEASE_LEAVE_ME_A_MESSAGE: 'Proszę zostaw wiadomość',
      MESSAGE_STAR: 'Wiadomość*',
      YOUR_MESSAGE_HERE: 'Twoja wiadomość',
      NAME: 'Imię',
      FIRST_NAME: 'Imię',
      LAST_NAME: 'Nazwisko',
      EMAIL: 'Email',
      INVALID_EMAIL: 'Nieprawidłowy email',
      INVALID_PHONE_NUMBER: 'Nieprawidłowy numer telefonu',
      OR: 'LUB',
      SCHEDULE_A_MEETING: 'Zaplanuj spotkanie',
      SEND_FB_MESSAGE: 'Wyślij wiadomość przez messengera',
      SEND_A_WHATSAPP: 'Wyślij wiadomość przez Whatsapp',
      PHONE: 'Telefon',
      PHONE_CALL: 'Zadzwoń',
      SEND: 'Wyślij',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Jak masz na imię?',
      WHAT_IS_YOUR_EMAIL: 'Jaki jest Twój email?',
      WHAT_IS_YOUR_PHONE: 'Jaki jest Twój numer telefonu?',
      WHAT_IS_YOUR_QUESTION: 'Jakie masz pytanie?'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Zaplanujmy nasze spotkanie',
      NEXT: 'Dalej',
      BACK: 'Cofnij',
      ADD_ANOTHER_OPTION: 'Dodaj kolejną opcję',
      GIVE_ALTERNATIVES: 'Aby ułatwić zaplanowanie spotkania, podaj kilka alternatyw',
      TIME_ZONE: 'Strefa czasowa',
      WHAT_IS_YOUR_EMAIL: 'Jaki jest Twój email?',
      ADD_NOTE: 'Dodaj notatkę...',
      INVALID_EMAIL: 'Nieprawidłowy email',
      THANKS_FOR_BOOKING: 'Dziękujemy za rezerwację',
      YOUR_REQUEST_WAS_SENT: 'Twoja prośba o spotkanie została wysłana i czeka na zatwierdzenie',
      WELL_GET_BACK: 'Odpowiemy Ci mailem',
      CHOOSE_TIME: 'Wybierz czas',
      ENTER_EMAIL: 'Podaj swój email',
      OPTIONAL: 'opcjonalnie',
      WHEN_DO_YOU_WANT_TO_MEET: 'Kiedy chcesz się spotkać',
      PICK_UP_TO_THREE: 'Dla tego spotkania wybierz maksymalnie trzy opcje. Twój klient będzie musiał wybrać jedną z nich.',
      SEND_INVITATION: 'Wyślij zaproszenie',
      INVITATION_FAILED: 'O-o... coś poszło nie tak. Sprawdź, proszę, czy termin spotkania nie jest ustawiony w przeszłości.',
      YOUR_NOTES: 'Twoje notatki',
      YOUR_PROPOSED_TIMES: 'Twój proponowany termin spotkania',
      RESCHEDULE_MEETING: 'Przełóż spotkanie',
      CANCEL_MEETING: 'Anuluj spotkanie',
      DECLINE_MEETING: 'Odmów',
      SURE_CANCEL: 'Czy na pewno chcesz anulować spotkanie?',
      YES_CANCEL: 'Tak, anuluj',
      NEVER_MIND: 'Nieważne',
      CANCELLED: 'Anulowane',
      RESCHEDULED: 'Zmieniony termin',
      DECLINED: 'Odmówione',
      CONFIRMED: 'Potwierdzone',
      ADD_TO_CALENDAR: 'Dodaj do kalendarza',
      REMOVE_FROM_CALENDAR: 'Usuń z kalendarza',
      SUGGEST_NEW_TIME: 'Zaproponuj nowy termin spotkania',
      SET_UPTO_THREE_OPTIONS: 'You can setup up to 3 options. One will be accepted.',
      REQUEST_SENT: 'Your request was sent',
      WAITING_FOR_APPROVAL: 'Waiting for approval.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Schedule another appointment',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SELECT_MEETING_DATE_AND_TIME: 'Select date and time',
      MEETING_DETAILS: 'Meeting Details'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Witam, jestem teraz niedostępny.',
      LEAVE_MESSAGE: 'Zostaw wiadomość',
      OR: 'lub',
      SCHEDULE_A_MEETING: 'zaplanuj spotkanie',
      TRY_AGAIN: 'Spróbuj ponownie',
      CALL_SETTINGS: 'Ustawienia połaczenia',
      CAMERA: 'Kamera',
      MICROPHONE: 'Mikrofon',
      SPEAKERS: 'Głośniki',
      CHAT: 'Chat',
      TEST: 'Test',
      VIDEO: 'Wideo',
      AUDIO: 'Tylko dźwięk',
      SHARE_SCREEN: 'Udostępnij ekran',
      CONNECTING: 'Łączę',
      RINGING: 'Dzwoni',
      SWITCH_CAMERA: 'Przełącz kamerę',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Rozłącz',
      ON_OFF: 'Wył./Wł.',
      PEER_IS_READY_PAYMENT: 'Twoja transakcja jest gotowa. Rozpocznij, proszę, płatność.',
      PAY_NOW: 'Zapłać teraz',
      CALL_END: 'Koniec rozmowy :)',
      CALL_NOW: 'Call now',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Call Ended',
      SELF_CONNECTION_CLOSED: 'Call Ended',
      CAMERA_ACCESS_PREVENTED: "We couldn't get access to the camera and/or microphone on this device. Please enable them first.",
      CAMERA_ACCESS_DIALOG_OPEN: 'Please approve the camera and microphone in order to start a video call.',
      REJECTED_CALL_MESSAGE: 'Please try again later',
      SELF_CALL_MESSAGE: "We're sorry. \\n You are trying to call yourself.",
      SWITCHING: 'Switching',
      ONLY_YOU_STREAM: 'Only you stream',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'W',
      SECONDS: 'sekund',
      PEOPLE_RECEIVED_CALLS_TODAY: 'Osoby, które otrzymały dzisiaj połaczenia.',
      SECURED: 'Zabezpieczony',
      FROM: 'Od',
      IS_CALLING_YOU: 'dzwoni do Ciebie',
      OVER_A_SECURED_WEBCALL: 'Poprzez bezpieczne połączenie internetowe',
      ACCEPT: 'Zaakceptuj',
      DECLINE: 'Odmów',
      CALL_REQUEST: 'Masz prośbę o połączenie',
      PAYMENT_REQUEST: 'Masz prośbę o płatność',
      PAY_NOW: 'Zapłać teraz',
      CANCEL: 'Anuluj',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  ARABIC: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'لنتحدث',
      MORE_INFO: 'المزيد من المعلومات',
      TALK_TO_ME_NOW: 'تحدث معي الان',
      FREE: 'مجانا!!',
      MINUTES: 'دقائق',
      VIDEO_CALL: 'مكالمة فيديو',
      SCHEDULE_A_MEETING: 'تحديد موعد إجتماع',
      SEND_FB_MESSAGE: 'إرسال رسالة فيسبوك',
      SEND_A_WHATSAPP: 'إرسال رسالة واتساب',
      PHONE_CALL: 'اتصل',
      YOUR_MESSAGE_HERE: 'رسالتك هنا',
      LEAVE_A_MESSAGE: 'اترك رسالة',
      SEND: 'إرسال',
      HOW_CAN_WE_REACH_YOU: 'كيف يمكننا التواصل معك؟',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'من أجل الرد عليك يرجى ترك التفاصيل الخاصة بك',
      NAME: 'الاسم',
      PHONE: 'الهاتف',
      EMAIL: 'البريد الإلكتروني',
      CHAT: 'محادثة',
      WEBCALL: 'مكالمة عبر الإنترنت',
      VIDEO: 'فيديو',
      SCHEDULE: 'جدول مواعيد',
      WHATSAPP: 'واتساب',
      MESSENGER: 'ماسنجر',
      MESSAGE: 'رسالة',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'قل شيئا',
      START_CHAT: 'ابدأ المحادثة',
      CONTACT: 'تواصل',
      ACTION_SELECTOR_HEADER: 'مرحبا!',
      TEXT_CHAT_HEADER: 'محادثة',
      WEBCALL_HEADER: 'مكالمة عبر الإنترنت',
      WHATSAPP_HEADER: 'واتساب',
      FB_MESSENGER_HEADER: 'ماسنجر',
      SCHEDULE_MEETING_HEADER: 'تحديد موعد إجتماع',
      PHONE_CALL_HEADER: 'الهاتف',
      INFO_COLLECTOR_HEADER: 'نموذج الاتصال'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'أنا غير موجود الآن',
      PLEASE_LEAVE_ME_A_MESSAGE: 'من فضلك أترك رسالة',
      MESSAGE_STAR: 'رسالة*',
      YOUR_MESSAGE_HERE: 'رسالتك هنا',
      NAME: 'الاسم',
      FIRST_NAME: 'الاسم الأول',
      LAST_NAME: 'اسم العائلة',
      EMAIL: 'البريد الإلكتروني',
      INVALID_EMAIL: 'البريد الإلكتروني غير صالح',
      INVALID_PHONE_NUMBER: 'رقم الهاتف غير صالح',
      OR: 'أو',
      SCHEDULE_A_MEETING: 'تحديد موعد إجتماع',
      SEND_FB_MESSAGE: 'إرسال رسالة فيسبوك',
      SEND_A_WHATSAPP: 'إرسال رسالة واتساب',
      PHONE: 'الهاتف',
      PHONE_CALL: 'اتصل',
      SEND: 'إرسال',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'ما اسمك؟',
      WHAT_IS_YOUR_EMAIL: 'ما هو بريدك الإلكتروني؟',
      WHAT_IS_YOUR_PHONE: 'ما هو رقم هاتفك؟',
      WHAT_IS_YOUR_QUESTION: 'ما هو سؤالك؟'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'دعنا نحدد موعدا لاجتماع',
      NEXT: 'التالي',
      BACK: 'السابق',
      ADD_ANOTHER_OPTION: 'أضف خيارًا آخر',
      GIVE_ALTERNATIVES: 'قدم بعض البدائل لتسهيل جدول المواعيد',
      TIME_ZONE: 'منطقة التوقيت',
      WHAT_IS_YOUR_EMAIL: 'ما هو بريدك الإلكتروني؟',
      ADD_NOTE: 'أضف ملاحظة...',
      INVALID_EMAIL: 'البريد الإلكتروني غير صالح',
      THANKS_FOR_BOOKING: 'شكرا على حجزك',
      YOUR_REQUEST_WAS_SENT: 'تم إرسال طلب الاجتماع الخاص بك وينتظر الموافقة.',
      WELL_GET_BACK: 'سنرد عليك عبر البريد الإلكتروني.',
      CHOOSE_TIME: 'اختر الوقت',
      ENTER_EMAIL: 'أدخل بريدك الإلكتروني',
      OPTIONAL: 'اختياري or غير إلزامي',
      WHEN_DO_YOU_WANT_TO_MEET: 'متى تريد ان نلتقي؟',
      PICK_UP_TO_THREE: 'اختر ما يصل إلى ثلاثة خيارات لهذا الاجتماع. سيحتاج عميلك إلى الموافقة على بديل واحد',
      SEND_INVITATION: 'أرسل الدعوة',
      INVITATION_FAILED: 'أوه ... حدث خطأ ما ... يرجى التحقق من أن أوقات الاجتماع ليست في الماضي',
      YOUR_NOTES: 'ملاحظاتك',
      YOUR_PROPOSED_TIMES: 'وقت الاجتماع المقترح',
      RESCHEDULE_MEETING: 'إعادة جدولة الاجتماع',
      CANCEL_MEETING: 'إلغاء الاجتماع',
      DECLINE_MEETING: 'رفض',
      SURE_CANCEL: 'هل أنت متأكد من رغبتك في إلغاء هذا الموعد؟',
      YES_CANCEL: 'نعم، إلغاء',
      NEVER_MIND: 'لا يهم',
      CANCELLED: 'ألغيت',
      RESCHEDULED: 'تحديد موعد جديد',
      DECLINED: 'رفض',
      CONFIRMED: 'مؤكد',
      ADD_TO_CALENDAR: 'إضافة إلى التقويم',
      REMOVE_FROM_CALENDAR: 'إزالة من التقويم',
      SUGGEST_NEW_TIME: 'اقترح وقتًا جديدًا للاجتماع',
      SET_UPTO_THREE_OPTIONS: 'يمكنك إعداد ما يصل إلى 3 خيارات. سيتم قبول واحد.',
      REQUEST_SENT: 'تم إرسال طلبك',
      WAITING_FOR_APPROVAL: 'في انتظار الموافقة.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'تحديد موعد آخر',
      EDIT: 'تعديل',
      DELETE: 'حذف',
      SELECT_MEETING_DATE_AND_TIME: 'حدد التاريخ والوقت',
      MEETING_DETAILS: 'تفاصيل الاجتماع'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'مرحبا، أنا لست متواجداً الآن.',
      LEAVE_MESSAGE: 'اترك لي رسالة',
      OR: 'أو',
      SCHEDULE_A_MEETING: 'تحديد موعد إجتماع.',
      TRY_AGAIN: 'حاول مرة أخرى',
      CALL_SETTINGS: 'إعدادات الاتصال',
      CAMERA: 'كاميرا',
      MICROPHONE: 'ميكروفون',
      SPEAKERS: 'سماعات',
      CHAT: 'Chat',
      TEST: 'اختبار',
      VIDEO: 'فيديو',
      AUDIO: 'صوت فقط',
      SHARE_SCREEN: 'مشاركة الشاشة',
      CONNECTING: 'الاتصال',
      RINGING: 'رنين',
      SWITCH_CAMERA: 'تبديل الكاميرا',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'أنهاء ألمحادثة ألهاتفية',
      ON_OFF: 'إيقاف/تشغيل',
      PEER_IS_READY_PAYMENT: 'نظيرك جاهز. يرجى البدء في الدفع',
      PAY_NOW: 'ادفع الان',
      CALL_END: 'المكالمة انتهت :)',
      CALL_NOW: 'اتصل الان',
      PEER_CONNECTION_CLOSED_MESSAGE: 'المكالمة انتهت',
      SELF_CONNECTION_CLOSED: 'المكالمة انتهت',
      CAMERA_ACCESS_PREVENTED: 'لم نتمكن من الوصول إلى الكاميرا و / أو الميكروفون على هذا الجهاز. يرجى تمكينهم أولا.',
      CAMERA_ACCESS_DIALOG_OPEN: 'يرجى الموافقة على الكاميرا والميكروفون لبدء مكالمة فيديو.',
      REJECTED_CALL_MESSAGE: 'الرجاء معاودة المحاولة في وقت لاحق',
      SELF_CALL_MESSAGE: 'نحن آسفون. أنت تحاول الاتصال بنفسك.',
      SWITCHING: 'تغيير',
      ONLY_YOU_STREAM: 'أنت وحدك من يقوم بالبث',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'في',
      SECONDS: 'ثوان',
      PEOPLE_RECEIVED_CALLS_TODAY: 'الأشخاص الذين تلقوا مكالمات اليوم.',
      SECURED: 'مضمون',
      FROM: 'من',
      IS_CALLING_YOU: 'يتصل بك',
      OVER_A_SECURED_WEBCALL: 'عبر مكالمة ويب آمنة',
      ACCEPT: 'إستقبل',
      DECLINE: 'رفض',
      CALL_REQUEST: 'لديك طلب مكالمة',
      PAYMENT_REQUEST: 'لديك طلب دفع',
      PAY_NOW: 'ادفع الان',
      CANCEL: 'إلغاء',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  NORWEGIAN: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Chat med meg',
      MORE_INFO: 'mer info',
      TALK_TO_ME_NOW: 'Chat med meg nå',
      FREE: 'gratis',
      MINUTES: 'minutter',
      VIDEO_CALL: 'videosamtale',
      SCHEDULE_A_MEETING: 'avtal et møte',
      SEND_FB_MESSAGE: 'send melding på Facebook messenger',
      SEND_A_WHATSAPP: 'send meldin med WhatsApp',
      PHONE_CALL: 'ring',
      YOUR_MESSAGE_HERE: 'skriv meldingen din her',
      LEAVE_A_MESSAGE: 'legg igjen en melding',
      SEND: 'send',
      HOW_CAN_WE_REACH_YOU: 'Hvordan kan jeg nå deg?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'For at jeg skal kunne svare deg, legg igjen informasjonen din',
      NAME: 'navn',
      PHONE: 'telefon',
      EMAIL: 'e-post',
      CHAT: 'chat',
      WEBCALL: 'webcall',
      VIDEO: 'video',
      SCHEDULE: 'avtal',
      WHATSAPP: 'WhatsAPP',
      MESSENGER: 'messenger',
      MESSAGE: 'melding',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Si noe',
      START_CHAT: 'Start Chat',
      CONTACT: 'Contact',
      ACTION_SELECTOR_HEADER: 'Welcome!',
      TEXT_CHAT_HEADER: 'chat',
      WEBCALL_HEADER: 'webcall',
      WHATSAPP_HEADER: 'WhatsAPP',
      FB_MESSENGER_HEADER: 'messenger',
      SCHEDULE_MEETING_HEADER: 'avtal et møte',
      PHONE_CALL_HEADER: 'telefon',
      INFO_COLLECTOR_HEADER: 'melding'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'jeg er ikke tilgjengelig akkurat nå',
      PLEASE_LEAVE_ME_A_MESSAGE: 'legg igjen en beskjed',
      MESSAGE_STAR: 'melding',
      YOUR_MESSAGE_HERE: 'Din melding her',
      NAME: 'navn',
      FIRST_NAME: 'fornavn',
      LAST_NAME: 'etternavn',
      EMAIL: 'e-post',
      INVALID_EMAIL: 'ugyldig e-post',
      INVALID_PHONE_NUMBER: 'ugyldig telefonnummer',
      OR: 'eller',
      SCHEDULE_A_MEETING: 'avtal et møte',
      SEND_FB_MESSAGE: 'send FB melding',
      SEND_A_WHATSAPP: 'send en WhatsApp',
      PHONE: 'telefon',
      PHONE_CALL: 'telefonsamtale',
      SEND: 'send',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'hva er ditt navn?',
      WHAT_IS_YOUR_EMAIL: 'hva er din e-epost?',
      WHAT_IS_YOUR_PHONE: 'hva er ditt telefonnummer?',
      WHAT_IS_YOUR_QUESTION: 'hva er ditt spørsmål?'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'La oss avtale et møte',
      NEXT: 'neste',
      BACK: 'tilbake',
      ADD_ANOTHER_OPTION: 'legg til et annet alternativ',
      GIVE_ALTERNATIVES: 'legg til noen alternativer for å gjøre en avtale lettere',
      TIME_ZONE: 'tidssone',
      WHAT_IS_YOUR_EMAIL: 'Hva er din e-post',
      ADD_NOTE: 'legg til et notat',
      INVALID_EMAIL: 'ugyldig e-post',
      THANKS_FOR_BOOKING: 'takk for bookingen',
      YOUR_REQUEST_WAS_SENT: 'møteforespørselen din er sendt og venter på godkjenning',
      WELL_GET_BACK: 'vi kommer tilbake til deg via e-post',
      CHOOSE_TIME: 'velg tid',
      ENTER_EMAIL: 'skriv din e-post',
      OPTIONAL: 'valgfri',
      WHEN_DO_YOU_WANT_TO_MEET: 'Når vil du møtes?',
      PICK_UP_TO_THREE: 'velg inntil 3 alternativer for møtet. Kunden din må godkjenne ett alterantiv',
      SEND_INVITATION: 'send invitasjon',
      INVITATION_FAILED: 'Ohh..noe gikk galt.. Kontroll at møtetidene ikke er I fortiden',
      YOUR_NOTES: 'dine notater',
      YOUR_PROPOSED_TIMES: 'din foreslåtte møtetid',
      RESCHEDULE_MEETING: 'Planlegg møte',
      CANCEL_MEETING: 'avbryt møte',
      DECLINE_MEETING: 'Avslå',
      SURE_CANCEL: 'Er du sikker på at du vil avlyse avtalen?',
      YES_CANCEL: 'ja, avlys',
      NEVER_MIND: 'glem det',
      CANCELLED: 'avlyst',
      RESCHEDULED: 'flyttet',
      DECLINED: 'avvist',
      CONFIRMED: 'bekreftet',
      ADD_TO_CALENDAR: 'legg til I kalender',
      REMOVE_FROM_CALENDAR: 'fjern fra kalender',
      SUGGEST_NEW_TIME: 'foreslå en ny tid for møte',
      SET_UPTO_THREE_OPTIONS: 'You can setup up to 3 options. One will be accepted.',
      REQUEST_SENT: 'Your request was sent',
      WAITING_FOR_APPROVAL: 'Waiting for approval.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Schedule another appointment',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SELECT_MEETING_DATE_AND_TIME: 'Select date and time',
      MEETING_DETAILS: 'Meeting Details'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Hei, jeg er ikke ledig akkurat nå',
      LEAVE_MESSAGE: 'legg igjen en melding',
      OR: 'eller',
      SCHEDULE_A_MEETING: 'Avtal et møte',
      TRY_AGAIN: 'prøv igjen',
      CALL_SETTINGS: 'telefoninstillinger',
      CAMERA: 'kamera',
      MICROPHONE: 'mikrofon',
      SPEAKERS: 'høyttalere',
      CHAT: 'Chat',
      TEST: 'test',
      VIDEO: 'video',
      AUDIO: 'kun lyd',
      SHARE_SCREEN: 'del skjerm',
      CONNECTING: 'kobler til',
      RINGING: 'ringer',
      SWITCH_CAMERA: 'bytt kamera',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'legg på ',
      ON_OFF: 'av/på',
      PEER_IS_READY_PAYMENT: 'det er klart. Vennligst start betalingen',
      PAY_NOW: 'betal nå',
      CALL_END: ' samtale slutt',
      CALL_NOW: 'Call now',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Call Ended',
      SELF_CONNECTION_CLOSED: 'Call Ended',
      CAMERA_ACCESS_PREVENTED: "We couldn't get access to the camera and/or microphone on this device. Please enable them first.",
      CAMERA_ACCESS_DIALOG_OPEN: 'Please approve the camera and microphone in order to start a video call.',
      REJECTED_CALL_MESSAGE: 'Please try again later',
      SELF_CALL_MESSAGE: "We're sorry. \\n You are trying to call yourself.",
      SWITCHING: 'Switching',
      ONLY_YOU_STREAM: 'Only you stream',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'på',
      SECONDS: 'sekunder',
      PEOPLE_RECEIVED_CALLS_TODAY: 'Folk mottok samtaler i dag',
      SECURED: 'sikker',
      FROM: 'fra',
      IS_CALLING_YOU: 'ringer deg',
      OVER_A_SECURED_WEBCALL: 'på sikker nettsamtale',
      ACCEPT: 'akseptere',
      DECLINE: 'avslå',
      CALL_REQUEST: 'du har en samtale forespørsel',
      PAYMENT_REQUEST: 'du har en betalingsforepørsel',
      PAY_NOW: 'betal på',
      CANCEL: 'avslå',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  SLOVAK: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Spojme sa',
      MORE_INFO: 'viac informácií',
      TALK_TO_ME_NOW: 'Kontaktuj ma',
      FREE: 'ZADARMO!!',
      MINUTES: 'Minúty',
      VIDEO_CALL: 'Videohovor',
      SCHEDULE_A_MEETING: 'Naplánovať stretnutie',
      SEND_FB_MESSAGE: 'Pošli správu cez Facebook',
      SEND_A_WHATSAPP: 'Pošlite správu cez WhatsApp',
      PHONE_CALL: 'Zavolať',
      YOUR_MESSAGE_HERE: 'Sem napíš tvoju správu',
      LEAVE_A_MESSAGE: 'Zanechaj správu',
      SEND: 'Odoslať',
      HOW_CAN_WE_REACH_YOU: 'Ako ťa môžeme kontaktovať?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Aby sme ťa mohli kontaktovať, zanechaj nám svoje údaje',
      NAME: 'Meno',
      PHONE: 'Telefón',
      EMAIL: 'Email',
      CHAT: 'Chat',
      WEBCALL: 'Online hovor',
      VIDEO: 'Video',
      SCHEDULE: 'Kalendár',
      WHATSAPP: 'WhatsApp',
      MESSENGER: 'Messenger',
      MESSAGE: 'Správa',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Povedz niečo',
      START_CHAT: 'Spusti chat',
      CONTACT: 'Kontakt',
      ACTION_SELECTOR_HEADER: 'Vitaj v Consolto',
      TEXT_CHAT_HEADER: 'Chat',
      WEBCALL_HEADER: 'Online hovor',
      WHATSAPP_HEADER: 'WhatsApp',
      FB_MESSENGER_HEADER: 'Messenger',
      SCHEDULE_MEETING_HEADER: 'Naplánuj si stretnutie',
      PHONE_CALL_HEADER: 'Telefón',
      INFO_COLLECTOR_HEADER: 'Kontaktný formulár'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'Momentálne nie som k dispozícii',
      PLEASE_LEAVE_ME_A_MESSAGE: 'zanechajte mi správu prosím',
      MESSAGE_STAR: 'Správa*',
      YOUR_MESSAGE_HERE: 'Sem napíš tvoju správu',
      NAME: 'Meno',
      FIRST_NAME: 'Krstné meno',
      LAST_NAME: 'Priezvisko',
      EMAIL: 'Email',
      INVALID_EMAIL: 'Neplatný email',
      INVALID_PHONE_NUMBER: 'Neplatné telefónne číslo',
      OR: 'ALEBO',
      SCHEDULE_A_MEETING: 'Naplánovať stretnutie',
      SEND_FB_MESSAGE: 'Pošli správu cez Facebook',
      SEND_A_WHATSAPP: 'Pošli správu cez WhatsApp ',
      PHONE: 'Telefón',
      PHONE_CALL: 'Zavolať',
      SEND: 'Odoslať',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Ako sa voláš?',
      WHAT_IS_YOUR_EMAIL: 'Aký je tvoj email?',
      WHAT_IS_YOUR_PHONE: 'Aké je tvoje telefónne číslo?',
      WHAT_IS_YOUR_QUESTION: 'Aká je tvoja otázka?'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Dohodnime si stretnutie',
      NEXT: 'Ďalej',
      BACK: 'Späť',
      ADD_ANOTHER_OPTION: 'Pridaj ďalšiu možnosť',
      GIVE_ALTERNATIVES: 'Pridaj niekoľko alternatív na uľahčenie plánovania',
      TIME_ZONE: 'Časové pásmo',
      WHAT_IS_YOUR_EMAIL: 'Aký je tvoj email?',
      ADD_NOTE: 'Pridať poznámku...',
      INVALID_EMAIL: 'Neplatný email',
      THANKS_FOR_BOOKING: 'Ďakujeme za rezerváciu',
      YOUR_REQUEST_WAS_SENT: 'Tvoja žiadosť o stretnutie bola odoslaná a čaká na schválenie.',
      WELL_GET_BACK: 'Ozveme sa ti e-mailom.',
      CHOOSE_TIME: 'Vyber si čas',
      ENTER_EMAIL: 'Zadaj svoj e-mail',
      OPTIONAL: 'voliteľné',
      WHEN_DO_YOU_WANT_TO_MEET: 'Na kedy chceš naplánovať stretnutie?',
      PICK_UP_TO_THREE: 'Vyber až tri možnosti pre toto stretnutie. Tvoj klient bude musieť schváliť jednu možnosť',
      SEND_INVITATION: 'Poslať pozvánku',
      INVITATION_FAILED: 'Och... niečo sa pokazilo... Skontroluj, či čas stretnutia nie je v minulosti',
      YOUR_NOTES: 'Tvoje poznámky',
      YOUR_PROPOSED_TIMES: 'Tvoj navrhovaný čas stretnutia',
      RESCHEDULE_MEETING: 'Zmeň termín stretnutia',
      CANCEL_MEETING: 'Zrušiť stretnutie',
      DECLINE_MEETING: 'Odmietnuť',
      SURE_CANCEL: 'Naozaj chceš zrušiť toto stretnutie?',
      YES_CANCEL: 'Áno, zrušiť',
      NEVER_MIND: 'Späť',
      CANCELLED: 'Zrušené',
      RESCHEDULED: 'Presunuté',
      DECLINED: 'Odmietnuté',
      CONFIRMED: 'Potvrdené',
      ADD_TO_CALENDAR: 'Pridať do kalendára',
      REMOVE_FROM_CALENDAR: 'Odstrániť z kalendára',
      SUGGEST_NEW_TIME: 'Navrhni nový čas stretnutia',
      SET_UPTO_THREE_OPTIONS: 'Môžeš uviesť až 3 možnosti. Jedna bude prijatá.',
      REQUEST_SENT: 'Tvoja žiadosť bola odoslaná',
      WAITING_FOR_APPROVAL: 'Čaká sa na schválenie.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Naplánuj si ďalšie stretnutie',
      EDIT: 'Upraviť',
      DELETE: 'Odstrániť',
      SELECT_MEETING_DATE_AND_TIME: 'Vyber čas a dátum ',
      MEETING_DETAILS: 'Podrobnosti o stretnutí'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Ahoj, momentálne nie som k dispozícii.',
      LEAVE_MESSAGE: 'Nezechaj mi správu',
      OR: 'alebo',
      SCHEDULE_A_MEETING: 'Naplánovať stretnutie.',
      TRY_AGAIN: 'Skús to znova',
      CALL_SETTINGS: 'Nastavenia hovoru',
      CAMERA: 'Kamera',
      MICROPHONE: 'Mikrofón',
      SPEAKERS: 'Reproduktory',
      CHAT: 'Chat',
      TEST: 'Test',
      VIDEO: 'Video',
      AUDIO: 'Iba zvuk',
      SHARE_SCREEN: 'Zdieľať obrazovku',
      CONNECTING: 'Pripája sa',
      RINGING: 'Zvonenie',
      SWITCH_CAMERA: 'Prepnúť kameru',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Zložiť',
      ON_OFF: 'Vypnúť/Zapnúť',
      PEER_IS_READY_PAYMENT: 'Druhý účastník je pripravený. Začni s platbou prosím',
      PAY_NOW: 'Zaplatiť',
      CALL_END: 'Hovor ukončený :)',
      CALL_NOW: 'Zavolať',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Hovor bol ukončený',
      SELF_CONNECTION_CLOSED: 'Hovor bol ukončený',
      CAMERA_ACCESS_PREVENTED: 'Nepodarilo sa nám získať prístup ku kamere a/alebo mikrofónu na tomto zariadení. Najprv ich povoľte.',
      CAMERA_ACCESS_DIALOG_OPEN: 'Ak chceš začať videohovor, povoľ kameru a mikrofón.',
      REJECTED_CALL_MESSAGE: 'Skús neskôr prosím',
      SELF_CALL_MESSAGE: 'Prepáč. \\n Pokúšaš sa zavolať sám sebe.',
      SWITCHING: 'Prepínam',
      ONLY_YOU_STREAM: 'Streamuješ iba ty',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'Za',
      SECONDS: 'sekúnd',
      PEOPLE_RECEIVED_CALLS_TODAY: 'Ľudia dnes prijali hovory',
      SECURED: 'Zabezpečené',
      FROM: 'Od',
      IS_CALLING_YOU: 'ti volá',
      OVER_A_SECURED_WEBCALL: 'cez bezpečený online hovor',
      ACCEPT: 'Prijať',
      DECLINE: 'Odmietnuť',
      CALL_REQUEST: 'Máš žiadosť o hovor',
      PAYMENT_REQUEST: 'Máš žiadosť o platbu',
      PAY_NOW: 'Zaplatiť',
      CANCEL: 'Zrušiť',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  'TRADITIONAL CHINESE': {
    CONSOLTO_WIDGET: {
      LETS_TALK: '跟我們來聊聊！',
      MORE_INFO: '了解更多',
      TALK_TO_ME_NOW: '現在與我交談',
      FREE: '免费!!',
      MINUTES: '分鐘',
      VIDEO_CALL: '視頻通話',
      SCHEDULE_A_MEETING: '安排會議',
      SEND_FB_MESSAGE: '發送 FB 訊息',
      SEND_A_WHATSAPP: '發送 WhatsApp 訊息',
      PHONE_CALL: '打電話',
      YOUR_MESSAGE_HERE: '你的消息在這裡',
      LEAVE_A_MESSAGE: '留言',
      SEND: '發送',
      HOW_CAN_WE_REACH_YOU: '我們如何聯繫您？',
      IN_ORDER_TO_GET_BACK_TO_YOU: '為了能夠回覆您，請留下您的聯絡方式',
      NAME: '姓名',
      PHONE: '電話',
      EMAIL: '電子郵件',
      CHAT: '聊天',
      WEBCALL: '網路電話',
      VIDEO: '視頻',
      SCHEDULE: '安排',
      WHATSAPP: 'Whatsapp',
      MESSENGER: 'Messenger',
      MESSAGE: '訊息',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: '說些什麼',
      START_CHAT: '開始聊天',
      CONTACT: '聯繫',
      ACTION_SELECTOR_HEADER: '歡迎！',
      TEXT_CHAT_HEADER: '聊天',
      WEBCALL_HEADER: '網路通話',
      WHATSAPP_HEADER: 'Whatsapp',
      FB_MESSENGER_HEADER: 'Messenger',
      SCHEDULE_MEETING_HEADER: '預約會議',
      PHONE_CALL_HEADER: '電話',
      INFO_COLLECTOR_HEADER: '聯繫表格'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: '我現在不方便',
      PLEASE_LEAVE_ME_A_MESSAGE: '留言',
      MESSAGE_STAR: '訊息',
      YOUR_MESSAGE_HERE: '您的訊息在這裡',
      NAME: '名字',
      FIRST_NAME: '名',
      LAST_NAME: '姓',
      EMAIL: '電子郵件',
      INVALID_EMAIL: '無效的電子郵件',
      INVALID_PHONE_NUMBER: '無效的電話號碼',
      OR: '或者',
      SCHEDULE_A_MEETING: '預約會議',
      SEND_FB_MESSAGE: '發送 FB 訊息',
      SEND_A_WHATSAPP: '發送 WhatsApp 訊息',
      PHONE: '電話',
      PHONE_CALL: '打電話',
      SEND: '發送',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: '您尊姓大名？',
      WHAT_IS_YOUR_EMAIL: '請問您的電子郵件是什麼？',
      WHAT_IS_YOUR_PHONE: '請問您的電話號碼是什麼？',
      WHAT_IS_YOUR_QUESTION: '請問您有什麼問題？'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: '請預約會議',
      NEXT: '下一步',
      BACK: '返回',
      ADD_ANOTHER_OPTION: '新增其他選項',
      GIVE_ALTERNATIVES: '提供幾個選項，讓預約流程更簡便',
      TIME_ZONE: '時區',
      WHAT_IS_YOUR_EMAIL: '請問您的電子郵件是什麼？',
      ADD_NOTE: '新增備註',
      INVALID_EMAIL: '無效的電子郵件',
      THANKS_FOR_BOOKING: '感謝您的預約',
      YOUR_REQUEST_WAS_SENT: '您的會議請求已發送並正在等待批准',
      WELL_GET_BACK: '我們將通過電子郵件與您聯繫',
      CHOOSE_TIME: '請選擇時間',
      ENTER_EMAIL: '請輸入您的電子郵件',
      OPTIONAL: '',
      WHEN_DO_YOU_WANT_TO_MEET: '您想什麼時候見面?',
      PICK_UP_TO_THREE: '選擇最多三個會議選項。您的客戶需要批准其中一個替代方案',
      SEND_INVITATION: '發送邀請',
      INVITATION_FAILED: '哎呀…出了些問題…請檢查會議時間是否不在過去',
      YOUR_NOTES: '您的筆記',
      YOUR_PROPOSED_TIMES: '您提議的會議時間',
      RESCHEDULE_MEETING: '重新安排會議',
      CANCEL_MEETING: '取消會議',
      DECLINE_MEETING: '拒絕',
      SURE_CANCEL: '您確定要取消這個約會嗎？',
      YES_CANCEL: '是的，取消',
      NEVER_MIND: '沒關係',
      CANCELLED: '已取消',
      RESCHEDULED: '已重新安排',
      DECLINED: '拒絕',
      CONFIRMED: '確認',
      ADD_TO_CALENDAR: '新增至行事曆',
      REMOVE_FROM_CALENDAR: '從行事曆中移除',
      SUGGEST_NEW_TIME: '建議新的會議時間',
      SET_UPTO_THREE_OPTIONS: '您可以設定最多 3 個選項。其中一個將被接受。',
      REQUEST_SENT: '您的請求已發送',
      WAITING_FOR_APPROVAL: '正在等待批准',
      SCHEDULE_ANOTHER_APPOINTMENT: '安排另一個預約',
      EDIT: '. 編輯',
      DELETE: '刪除',
      SELECT_MEETING_DATE_AND_TIME: '選擇日期和時間',
      MEETING_DETAILS: '會議詳情'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: '我現在不方便',
      LEAVE_MESSAGE: '留言',
      OR: '或者',
      SCHEDULE_A_MEETING: '預約會議',
      TRY_AGAIN: '再試一次',
      CALL_SETTINGS: '通話設定',
      CAMERA: '攝像頭',
      MICROPHONE: '麥克風',
      SPEAKERS: '揚聲器',
      CHAT: 'Chat',
      TEST: '測試',
      VIDEO: '視訊',
      AUDIO: '僅音頻',
      SHARE_SCREEN: '分享螢幕',
      CONNECTING: '連線中',
      RINGING: '響鈴中',
      SWITCH_CAMERA: '切換攝像頭',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: '掛斷',
      ON_OFF: '開啟/關閉',
      PEER_IS_READY_PAYMENT: '對方已準備就緒。請開始付款',
      PAY_NOW: '立即付款',
      CALL_END: '通話已結束 ',
      CALL_NOW: '立即通話',
      PEER_CONNECTION_CLOSED_MESSAGE: '通話已結束',
      SELF_CONNECTION_CLOSED: '通話已結束',
      CAMERA_ACCESS_PREVENTED: '我們無法訪問此設備上的攝像頭和/或麥克風。請先啟用它們。',
      CAMERA_ACCESS_DIALOG_OPEN: '請允許攝像頭和麥克風以開始視訊通話。',
      REJECTED_CALL_MESSAGE: '請稍後再試。',
      SELF_CALL_MESSAGE: '抱歉，您正在試圖呼叫自己。',
      SWITCHING: '切換中',
      ONLY_YOU_STREAM: '僅您在串流',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: '中',
      SECONDS: '秒',
      PEOPLE_RECEIVED_CALLS_TODAY: '今天已接通的人數',
      SECURED: '已安全',
      FROM: '來自',
      IS_CALLING_YOU: '正在呼叫您”',
      OVER_A_SECURED_WEBCALL: '透過安全的網路通話」：透過安全的網路通話。',
      ACCEPT: '接受',
      DECLINE: '拒絕',
      CALL_REQUEST: '您有一個通話請求',
      PAYMENT_REQUEST: '您有一個付款請求',
      PAY_NOW: '立即支付',
      CANCEL: '取消',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  VIETNAMESE: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Hãy trò chuyện',
      MORE_INFO: 'muốn biết thêm thông tin',
      TALK_TO_ME_NOW: 'Trò chuyện với tôi ngay bây giờ',
      FREE: 'MIỄN PHÍ!!',
      MINUTES: 'Phút',
      VIDEO_CALL: 'Gọi video',
      SCHEDULE_A_MEETING: 'Lên lịch cuộc họp',
      SEND_FB_MESSAGE: 'Gửi tin nhắn FB',
      SEND_A_WHATSAPP: 'Gửi tin nhắn whatsapp',
      PHONE_CALL: 'Gọi',
      YOUR_MESSAGE_HERE: 'Tin nhắn của bạn ở đây ',
      LEAVE_A_MESSAGE: 'Để lại lời nhắn',
      SEND: 'Gửi',
      HOW_CAN_WE_REACH_YOU: 'Chúng tôi có thể liên lạc với bạn bằng cách nào?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'Để chúng tôi liên hệ lại với bạn, vui lòng để lại thông tin chi tiết của bạn',
      NAME: 'Tên',
      PHONE: 'Điện thoại',
      EMAIL: 'E-mail',
      CHAT: 'Trò Chuyện',
      WEBCALL: 'Cuộc Gọi Web',
      VIDEO: 'Video',
      SCHEDULE: 'Cuộc Hẹn',
      WHATSAPP: 'Whatsapp',
      MESSENGER: 'Messenger',
      MESSAGE: 'Tin nhắn',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Hãy nói điều gì đó',
      START_CHAT: 'Bắt đầu trò chuyện',
      CONTACT: 'Liên hệ',
      ACTION_SELECTOR_HEADER: 'Chào mừng!',
      TEXT_CHAT_HEADER: 'Trò chuyện',
      WEBCALL_HEADER: 'Cuộc Gọi Web',
      WHATSAPP_HEADER: 'Whatsapp',
      FB_MESSENGER_HEADER: 'Messenger',
      SCHEDULE_MEETING_HEADER: 'Lịch họp',
      PHONE_CALL_HEADER: 'Điện thoại',
      INFO_COLLECTOR_HEADER: 'Mẫu liên hệ'
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'Tôi không có mặt ngay bây giờ',
      PLEASE_LEAVE_ME_A_MESSAGE: 'Vui lòng để lại cho tôi một tin nhắn',
      MESSAGE_STAR: 'Tin nhắn*',
      YOUR_MESSAGE_HERE: 'Tin nhắn của bạn ở đây',
      NAME: 'Tên',
      FIRST_NAME: 'Tên',
      LAST_NAME: 'Họ',
      EMAIL: 'E-mail',
      INVALID_EMAIL: 'Email không hợp lệ',
      INVALID_PHONE_NUMBER: 'Số điện thoại không hợp lệ',
      OR: 'HOẶC',
      SCHEDULE_A_MEETING: 'Lên lịch cuộc họp',
      SEND_FB_MESSAGE: 'Gửi tin nhắn FB',
      SEND_A_WHATSAPP: 'Gửi tin nhắn WhatsApp',
      PHONE: 'Điện thoại',
      PHONE_CALL: 'Gọi',
      SEND: 'Gửi',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Tên bạn là gì?',
      WHAT_IS_YOUR_EMAIL: 'Email của bạn là gì?',
      WHAT_IS_YOUR_PHONE: 'Số điện thoại của bạn là gì?',
      WHAT_IS_YOUR_QUESTION: 'Câu hỏi của bạn là gì?'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Hãy lên lịch một cuộc họp',
      NEXT: 'Kế tiếp',
      BACK: 'Trở lại',
      ADD_ANOTHER_OPTION: 'Thêm một tùy chọn khác',
      GIVE_ALTERNATIVES: 'Cung cấp một số tùy chọn để làm cho quá trình đặt lịch dễ dàng hơn',
      TIME_ZONE: 'Múi giờ',
      WHAT_IS_YOUR_EMAIL: 'Email của bạn là gì?',
      ADD_NOTE: 'Thêm một lưu ý...',
      INVALID_EMAIL: 'Email không hợp lệ',
      THANKS_FOR_BOOKING: 'Cảm ơn bạn đã đặt phòng',
      YOUR_REQUEST_WAS_SENT: 'Yêu cầu cuộc họp của bạn đã được gửi và đang chờ phê duyệt.',
      WELL_GET_BACK: 'Chúng tôi sẽ liên hệ lại với bạn qua email.',
      CHOOSE_TIME: 'Chọn thời gian',
      ENTER_EMAIL: 'Nhập email của bạn',
      OPTIONAL: 'không bắt buộc',
      WHEN_DO_YOU_WANT_TO_MEET: 'Bạn muốn gặp nhau khi nào?',
      PICK_UP_TO_THREE: 'Chọn tối đa ba lựa chọn cho cuộc họp này. Khách hàng của bạn sẽ cần phê duyệt một giải pháp thay thế',
      SEND_INVITATION: 'Gửi lời mời',
      INVITATION_FAILED: 'Ồ ... đã xảy ra sự cố ... Vui lòng kiểm tra xem thời gian họp có phải là trong quá khứ không?',
      YOUR_NOTES: 'Ghi chú của bạn',
      YOUR_PROPOSED_TIMES: 'Thời gian họp được đề xuất của bạn',
      RESCHEDULE_MEETING: 'Lên lịch lại cuộc họp',
      CANCEL_MEETING: 'Hủy cuộc họp',
      DECLINE_MEETING: 'Từ chối',
      SURE_CANCEL: 'Bạn có chắc là bạn muốn hủy cuộc hẹn này?',
      YES_CANCEL: 'Có, hủy bỏ',
      NEVER_MIND: 'Đừng bận tâm',
      CANCELLED: 'Bị hủy bỏ',
      RESCHEDULED: 'Lên lịch lại',
      DECLINED: 'Đã từ chối',
      CONFIRMED: 'Đã xác nhận',
      ADD_TO_CALENDAR: 'Thêm vào lịch',
      REMOVE_FROM_CALENDAR: 'Hủy bỏ cuộc hẹn từ lịch',
      SUGGEST_NEW_TIME: 'Đề xuất thời gian mới cho cuộc họp',
      SET_UPTO_THREE_OPTIONS: 'Bạn có thể thiết lập tối đa 3 tùy chọn. Một trong số đó sẽ được chấp nhận.',
      REQUEST_SENT: 'Yêu cầu của bạn đã được gửi',
      WAITING_FOR_APPROVAL: 'Chờ phê duyệt.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Lên lịch một cuộc hẹn khác',
      EDIT: 'Chỉnh sửa',
      DELETE: 'Xóa bỏ',
      SELECT_MEETING_DATE_AND_TIME: 'Chọn ngày và giờ',
      MEETING_DETAILS: 'Chi Tiết Cuộc Họp'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Xin chào, tôi không có mặt ngay bây giờ.',
      LEAVE_MESSAGE: 'Để lại cho tôi một tin nhắn',
      OR: 'hoặc',
      SCHEDULE_A_MEETING: 'Lên lịch cuộc họp.',
      TRY_AGAIN: 'Thử lại',
      CALL_SETTINGS: 'Cài Đặt Cuộc Gọi',
      CAMERA: 'Máy ảnh',
      MICROPHONE: 'Micrô',
      SPEAKERS: 'Loa',
      CHAT: 'Chat',
      TEST: 'Bài kiểm tra',
      VIDEO: 'Video',
      AUDIO: 'Chỉ có âm thanh',
      SHARE_SCREEN: 'Chia sẻ màn hình',
      CONNECTING: 'Đang kết nối',
      RINGING: 'Đổ chuông',
      SWITCH_CAMERA: 'Chuyển đổi camera',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'kết thúc cuộc gọi',
      ON_OFF: 'Tắt/Mở',
      PEER_IS_READY_PAYMENT: 'Đối tác của bạn đã sẵn sàng. Vui lòng bắt đầu thanh toán',
      PAY_NOW: 'Thanh toán ngay',
      CALL_END: 'Cuộc gọi kết thúc :)',
      CALL_NOW: 'Gọi ngay bây giờ',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Cuộc Gọi Kết Thúc',
      SELF_CONNECTION_CLOSED: 'Cuộc Gọi Kết Thúc',
      CAMERA_ACCESS_PREVENTED: 'Chúng tôi không thể truy cập vào máy ảnh và/hoặc micrô trên thiết bị này. Vui lòng bật chúng trước.',
      CAMERA_ACCESS_DIALOG_OPEN: 'Vui lòng phê duyệt máy ảnh và micrô để bắt đầu cuộc gọi video.',
      REJECTED_CALL_MESSAGE: 'Vui lòng thử lại sau',
      SELF_CALL_MESSAGE: 'Chúng tôi xin lỗi. Bạn đang cố gắng tự gọi mình.',
      SWITCHING: 'Chuyển đổi',
      ONLY_YOU_STREAM: 'Chỉ có bạn phát trực tuyến',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'Trong',
      SECONDS: 'Giây',
      PEOPLE_RECEIVED_CALLS_TODAY: 'Mọi người nhận được cuộc gọi hôm nay',
      SECURED: 'Được bảo đảm',
      FROM: 'Từ',
      IS_CALLING_YOU: 'đang gọi cho bạn',
      OVER_A_SECURED_WEBCALL: 'qua một cuộc gọi web được bảo mật',
      ACCEPT: 'Chấp nhận',
      DECLINE: 'Hủy bỏ',
      CALL_REQUEST: 'Bạn có một yêu cầu cuộc gọi',
      PAYMENT_REQUEST: 'Bạn có một yêu cầu thanh toán',
      PAY_NOW: 'Thanh toán ngay',
      CANCEL: 'Hủy bỏ',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  },
  BULGARIAN: {
    CONSOLTO_WIDGET: {
      LETS_TALK: 'Нека поговорим',
      MORE_INFO: 'повече информация',
      TALK_TO_ME_NOW: 'Говори с мен сега',
      FREE: 'БЕЗПЛАТНО!',
      MINUTES: 'Минути',
      VIDEO_CALL: 'Видео обаждане',
      SCHEDULE_A_MEETING: 'Запази среща',
      SEND_FB_MESSAGE: 'Изпрати съобщение във FB',
      SEND_A_WHATSAPP: 'Изпрати съобщение във WhatsApp',
      PHONE_CALL: 'Обаждане',
      YOUR_MESSAGE_HERE: 'Твоето съобщение тук',
      LEAVE_A_MESSAGE: 'Остави съобщение',
      SEND: 'Изпрати',
      HOW_CAN_WE_REACH_YOU: 'Как да се свържем с теб?',
      IN_ORDER_TO_GET_BACK_TO_YOU: 'За да се свържем с теб, моля, остави данните си',
      NAME: 'Име',
      PHONE: 'Телефон',
      EMAIL: 'Имейл',
      CHAT: 'Чат',
      WEBCALL: 'Уеб обаждане',
      VIDEO: 'Видео обаждане',
      SCHEDULE: 'График',
      WHATSAPP: 'Whatsapp',
      MESSENGER: 'Messenger',
      MESSAGE: 'Съобщение',
      POWERED_BY_CONSOLTO: 'Powered by Consolto',
      SAY_SOMETHING: 'Кажи нещо',
      START_CHAT: 'Започни чат',
      CONTACT: 'Контакт',
      ACTION_SELECTOR_HEADER: 'Добре дошъл!',
      TEXT_CHAT_HEADER: 'Чат',
      WEBCALL_HEADER: 'Уеб обаждане',
      WHATSAPP_HEADER: 'Whatsapp',
      FB_MESSENGER_HEADER: 'Messenger',
      SCHEDULE_MEETING_HEADER: 'Запази среща',
      PHONE_CALL_HEADER: 'Телефон',
      INFO_COLLECTOR_HEADER: 'Контактна форма'
    }
  },
  '': {
    CONSOLTO_WIDGET: {
      LETS_TALK: '',
      MORE_INFO: '',
      TALK_TO_ME_NOW: '',
      FREE: '',
      MINUTES: '',
      VIDEO_CALL: '',
      SCHEDULE_A_MEETING: '',
      SEND_FB_MESSAGE: '',
      SEND_A_WHATSAPP: '',
      PHONE_CALL: '',
      YOUR_MESSAGE_HERE: '',
      LEAVE_A_MESSAGE: '',
      SEND: '',
      HOW_CAN_WE_REACH_YOU: '',
      IN_ORDER_TO_GET_BACK_TO_YOU: '',
      NAME: '',
      PHONE: '',
      EMAIL: '',
      CHAT: '',
      WEBCALL: '',
      VIDEO: '',
      SCHEDULE: '',
      WHATSAPP: '',
      MESSENGER: '',
      MESSAGE: '',
      POWERED_BY_CONSOLTO: '',
      SAY_SOMETHING: '',
      START_CHAT: '',
      CONTACT: '',
      ACTION_SELECTOR_HEADER: '',
      TEXT_CHAT_HEADER: '',
      WEBCALL_HEADER: '',
      WHATSAPP_HEADER: '',
      FB_MESSENGER_HEADER: '',
      SCHEDULE_MEETING_HEADER: '',
      PHONE_CALL_HEADER: '',
      INFO_COLLECTOR_HEADER: ''
    },
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: '',
      PLEASE_LEAVE_ME_A_MESSAGE: '',
      MESSAGE_STAR: '',
      YOUR_MESSAGE_HERE: '',
      NAME: '',
      FIRST_NAME: '',
      LAST_NAME: '',
      EMAIL: '',
      INVALID_EMAIL: '',
      INVALID_PHONE_NUMBER: '',
      OR: '',
      SCHEDULE_A_MEETING: '',
      SEND_FB_MESSAGE: '',
      SEND_A_WHATSAPP: '',
      PHONE: '',
      PHONE_CALL: '',
      SEND: '',
      FORM_SUBMISSION: '',
      WHAT_IS_YOUR_NAME: '',
      WHAT_IS_YOUR_EMAIL: '',
      WHAT_IS_YOUR_PHONE: '',
      WHAT_IS_YOUR_QUESTION: ''
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: '',
      NEXT: '',
      BACK: '',
      ADD_ANOTHER_OPTION: '',
      GIVE_ALTERNATIVES: '',
      TIME_ZONE: '',
      WHAT_IS_YOUR_EMAIL: '',
      ADD_NOTE: '',
      INVALID_EMAIL: '',
      THANKS_FOR_BOOKING: '',
      YOUR_REQUEST_WAS_SENT: '',
      WELL_GET_BACK: '',
      CHOOSE_TIME: '',
      ENTER_EMAIL: '',
      OPTIONAL: '',
      WHEN_DO_YOU_WANT_TO_MEET: '',
      PICK_UP_TO_THREE: '',
      SEND_INVITATION: '',
      INVITATION_FAILED: '',
      YOUR_NOTES: '',
      YOUR_PROPOSED_TIMES: '',
      RESCHEDULE_MEETING: '',
      CANCEL_MEETING: '',
      DECLINE_MEETING: '',
      SURE_CANCEL: '',
      YES_CANCEL: '',
      NEVER_MIND: '',
      CANCELLED: '',
      RESCHEDULED: '',
      DECLINED: '',
      CONFIRMED: '',
      ADD_TO_CALENDAR: '',
      REMOVE_FROM_CALENDAR: '',
      SUGGEST_NEW_TIME: '',
      SET_UPTO_THREE_OPTIONS: '',
      REQUEST_SENT: '',
      WAITING_FOR_APPROVAL: '',
      SCHEDULE_ANOTHER_APPOINTMENT: '',
      EDIT: '',
      DELETE: '',
      SELECT_MEETING_DATE_AND_TIME: '',
      MEETING_DETAILS: ''
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: '',
      LEAVE_MESSAGE: '',
      OR: '',
      SCHEDULE_A_MEETING: '',
      TRY_AGAIN: '',
      CALL_SETTINGS: '',
      CAMERA: '',
      MICROPHONE: '',
      SPEAKERS: '',
      CHAT: '',
      TEST: '',
      VIDEO: '',
      AUDIO: '',
      SHARE_SCREEN: '',
      CONNECTING: '',
      RINGING: '',
      SWITCH_CAMERA: '',
      BACKGROUND_EFFECTS: '',
      BLUR: '',
      CLOSE: '',
      SET_BACKGROUND: '',
      HANGUP: '',
      ON_OFF: '',
      PEER_IS_READY_PAYMENT: '',
      PAY_NOW: '',
      CALL_END: '',
      CALL_NOW: '',
      PEER_CONNECTION_CLOSED_MESSAGE: '',
      SELF_CONNECTION_CLOSED: '',
      CAMERA_ACCESS_PREVENTED: '',
      CAMERA_ACCESS_DIALOG_OPEN: '',
      REJECTED_CALL_MESSAGE: '',
      SELF_CALL_MESSAGE: '',
      SWITCHING: '',
      ONLY_YOU_STREAM: '',
      DIRECT_CALL: '',
      OPEN_MEETING_IN_CONSOLTO: '',
      CONSOLTO: '',
      STAY_HERE: '',
      INVALID_MEETING_LINK: '',
      SESSION_UNAVAILABLE: '',
      SEND_MSG_OR_ARRANGE_MEETING: '',
      SCHEDULE_NEW_MEETING: '',
      WHEN_READY_ENTER_MEETING: '',
      MEETING_STARTS_IN: '',
      MEETING_TIME_ARRIVED: '',
      MEETING_OVER: '',
      MEETING_NOT_STARTED: '',
      MEETING_STARTED: '',
      ANOTHER_MEETING: '',
      WILL_JOIN_SOON: '',
      HAS_JOINED: '',
      YOU_LEFT_MEETTING: '',
      READY: '',
      MEETING_ROOM_FULL: '',
      RECONNECT: '',
      ENTER_MEETING: '',
      ARE_YOU_HOST: '',
      JOIN_HERE: '',
      PARTICIPANTS: '',
      ENABLE_CAMERA: '',
      ENABLE_MICROPHONE: '',
      ENABLE_MICROPHONE_CAMERA: '',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: '',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: '',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: '',
      CAMERA_BLOCKED: '',
      MICROPHONE_BLOCKED: '',
      CAMERA_MICROPHONE_BLOCKED: '',
      NEED_HELP: '',
      CLICK_TO_ENABLE: '',
      MEETING_TITLE: '',
      EXIT_FULL_SCREEN: '',
      FULL_SCREEN_STREAM: '',
      FULL_SCREEN_WINDOW: '',
      MINIMIZE_STREAM: '',
      MAXIMIZE_STREAM: '',
      MINIMIZE_MEETING: '',
      MAXIMIZE_MEETING: '',
      GALLERY_VIEW_MODE: '',
      CALL_BEING_RECORDED: ''
    },
    ACTIVE_AGENT: {
      IN: '',
      SECONDS: '',
      PEOPLE_RECEIVED_CALLS_TODAY: '',
      SECURED: '',
      FROM: '',
      IS_CALLING_YOU: '',
      OVER_A_SECURED_WEBCALL: '',
      ACCEPT: '',
      DECLINE: '',
      CALL_REQUEST: '',
      PAYMENT_REQUEST: '',
      PAY_NOW: '',
      CANCEL: '',
      END_FILE_KEEP_THIS_IN_THE_END: '',
      '': ''
    }
  },
  'БЪЛГАРСКИ': {
    INFO_COLLECTOR: {
      IM_NOT_AVAILABLE: 'Не съм на линия в момента',
      PLEASE_LEAVE_ME_A_MESSAGE: 'Моля, остави съобщение',
      MESSAGE_STAR: 'Съобщение*',
      YOUR_MESSAGE_HERE: 'Твоето съобщение тук',
      NAME: 'Имена',
      FIRST_NAME: 'Име',
      LAST_NAME: 'Фамилия',
      EMAIL: 'Имейл',
      INVALID_EMAIL: 'Невалиден имейл',
      INVALID_PHONE_NUMBER: 'Невалиден телефонен номер',
      OR: 'ИЛИ',
      SCHEDULE_A_MEETING: 'Запази среща',
      SEND_FB_MESSAGE: 'Изпрати FB съобщение',
      SEND_A_WHATSAPP: 'Изпрати WhatsApp съобщение',
      PHONE: 'Телефон',
      PHONE_CALL: 'Обаждане',
      SEND: 'Изпрати',
      FORM_SUBMISSION: 'Thank you. We have received the information and will get back to you promptly',
      WHAT_IS_YOUR_NAME: 'Какво е твоето име?',
      WHAT_IS_YOUR_EMAIL: 'Какъв е твоят имейл?',
      WHAT_IS_YOUR_PHONE: 'Какъв е твоят телефонен номер?',
      WHAT_IS_YOUR_QUESTION: 'Какъв е твоят въпрос?'
    },
    SCHEDULING: {
      LETS_SCHEDULE_MEETING: 'Запази среща',
      NEXT: 'Следващ',
      BACK: 'Предишен',
      ADD_ANOTHER_OPTION: 'Добави друга опция',
      GIVE_ALTERNATIVES: 'Дайте няколко алтернативи, за да улесните процеса на планиране',
      TIME_ZONE: 'Часова зона',
      WHAT_IS_YOUR_EMAIL: 'Какъв е твоят имейл?',
      ADD_NOTE: 'Остави бележка...',
      INVALID_EMAIL: 'Невалиден имейл',
      THANKS_FOR_BOOKING: 'Благодарим за резервацията',
      YOUR_REQUEST_WAS_SENT: 'Вашата заявка за среща е изпратена и чака одобрение.',
      WELL_GET_BACK: 'Ще се свържем с вас по имейл.',
      CHOOSE_TIME: 'Избери време',
      ENTER_EMAIL: 'Въведи имейл',
      OPTIONAL: 'опцинален',
      WHEN_DO_YOU_WANT_TO_MEET: 'Кога искаш да се видим?',
      PICK_UP_TO_THREE: 'Изберете до три опции за тази среща. Вашият клиент ще трябва да одобри една алтернатива',
      SEND_INVITATION: 'Изпрати покана',
      INVITATION_FAILED: 'Ох... нещо се обърка... Моля, проверете дали часовете на срещите не са в миналото',
      YOUR_NOTES: 'Вашите бележки',
      YOUR_PROPOSED_TIMES: 'Вашият предложен час за среща',
      RESCHEDULE_MEETING: 'Пренасрочване на срещата',
      CANCEL_MEETING: 'Отмяна на срещата',
      DECLINE_MEETING: 'Откажи',
      SURE_CANCEL: 'Сигурни ли сте, че искате да отмените тази среща?',
      YES_CANCEL: 'Да, Отказ',
      NEVER_MIND: 'Няма значение',
      CANCELLED: 'Отменен',
      RESCHEDULED: 'Пренасрочено',
      DECLINED: 'Отказано',
      CONFIRMED: 'Прието',
      ADD_TO_CALENDAR: 'Добави в календара',
      REMOVE_FROM_CALENDAR: 'Премахни от календара',
      SUGGEST_NEW_TIME: 'Предложете нов час за среща',
      SET_UPTO_THREE_OPTIONS: 'Можете да настроите до 3 опции. Един ще бъде приет.',
      REQUEST_SENT: 'Вашата заявка беше изпратена',
      WAITING_FOR_APPROVAL: 'В очакване на одобрение.',
      SCHEDULE_ANOTHER_APPOINTMENT: 'Насрочете друга среща',
      EDIT: 'Редактиране',
      DELETE: 'Изтриване',
      SELECT_MEETING_DATE_AND_TIME: 'Избери време и час',
      MEETING_DETAILS: 'Подробности за срещата'
    },
    VIDEO_CALL_CAT: {
      IM_NOT_AVAILABLE: 'Здравейте, в момента не съм свободен.',
      LEAVE_MESSAGE: 'Оставете ми съобщение',
      OR: 'или',
      SCHEDULE_A_MEETING: 'Планирай среща.',
      TRY_AGAIN: 'Опитай отново',
      CALL_SETTINGS: 'Настройки за повикване',
      CAMERA: 'Камера',
      MICROPHONE: 'Микрофон',
      SPEAKERS: 'Високоговорители',
      CHAT: 'Chat',
      TEST: 'Тест',
      VIDEO: 'Видео',
      AUDIO: 'Само звук',
      SHARE_SCREEN: 'Сподели екран',
      CONNECTING: 'Свързване',
      RINGING: 'Позвъняване',
      SWITCH_CAMERA: 'Превключване на камерата',
      BACKGROUND_EFFECTS: 'Background effects',
      BLUR: 'Blur',
      CLOSE: 'Close',
      SET_BACKGROUND: 'Set Background',
      HANGUP: 'Затварям',
      ON_OFF: 'Изкл. / Вкл.',
      PEER_IS_READY_PAYMENT: 'Готово е. Моля, започнете плащането',
      PAY_NOW: 'Плати сега.',
      CALL_END: 'Обаждането завърши :)',
      CALL_NOW: 'Обади се сега',
      PEER_CONNECTION_CLOSED_MESSAGE: 'Обаждането завърши ',
      SELF_CONNECTION_CLOSED: 'Обаждането завърши ',
      CAMERA_ACCESS_PREVENTED: 'Не можахме да получим достъп до камерата и/или микрофона на това устройство. Моля, първо ги активирайте.',
      CAMERA_ACCESS_DIALOG_OPEN: 'Моля, одобрете камерата и микрофона, за да започнете видео разговор.',
      REJECTED_CALL_MESSAGE: 'Моля, опитайте отново по-късно',
      SELF_CALL_MESSAGE: 'Съжаляваме. \\n Опитвате се да се обадите на себе си.',
      SWITCHING: 'Превключване',
      ONLY_YOU_STREAM: 'Само вие стриймвате',
      DIRECT_CALL: 'For direct calls, please open this link in your default brower.',
      OPEN_MEETING_IN_CONSOLTO: 'Open this meeting in Consolto?',
      CONSOLTO: 'Consolto',
      STAY_HERE: 'Stay here',
      INVALID_MEETING_LINK: 'Invalid meeting link',
      SESSION_UNAVAILABLE: 'The session is no longer available',
      SEND_MSG_OR_ARRANGE_MEETING: 'You can send a message or arrange a meeting with the',
      SCHEDULE_NEW_MEETING: 'Schedule new meeting',
      WHEN_READY_ENTER_MEETING: 'When ready, enter the meeting',
      MEETING_STARTS_IN: 'Meeting starts in:',
      MEETING_TIME_ARRIVED: 'The meeting time has arrived',
      MEETING_OVER: 'This meeting is over',
      MEETING_NOT_STARTED: "This meeting hasn't started yet",
      MEETING_STARTED: 'The meeting has started',
      ANOTHER_MEETING: 'is in another meeting\\nand will join soon',
      WILL_JOIN_SOON: 'will join soon',
      HAS_JOINED: 'has already joined.',
      YOU_LEFT_MEETTING: 'You left the meeting',
      READY: 'Ready?',
      MEETING_ROOM_FULL: 'Meeting room is full',
      RECONNECT: 'Reconnect?',
      ENTER_MEETING: 'Enter the meeting',
      ARE_YOU_HOST: 'Are you the host of this meeting?',
      JOIN_HERE: 'Join here',
      PARTICIPANTS: 'Participants',
      ENABLE_CAMERA: 'Enable camera',
      ENABLE_MICROPHONE: 'Enable microphone',
      ENABLE_MICROPHONE_CAMERA: 'Enable microphone and camera',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA: 'Please provide access to your camera. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_MICROPHONE: 'Please provide access to your microphone. You can always turn it off later.',
      PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE: 'Please provide access to your camera and microphone. You can always turn them off later.',
      CAMERA_BLOCKED: 'Camera blocked',
      MICROPHONE_BLOCKED: 'Microphone blocked',
      CAMERA_MICROPHONE_BLOCKED: 'Camera and Microphone blocked',
      NEED_HELP: 'Need help?',
      CLICK_TO_ENABLE: 'Click here to enable',
      MEETING_TITLE: 'Meeting title',
      EXIT_FULL_SCREEN: 'Exit of full screen',
      FULL_SCREEN_STREAM: 'Full screen this stream',
      FULL_SCREEN_WINDOW: 'Full screen window',
      MINIMIZE_STREAM: 'Minimize stream',
      MAXIMIZE_STREAM: 'Maximize stream',
      MINIMIZE_MEETING: 'Minimize meeting',
      MAXIMIZE_MEETING: 'Maximize meeting',
      GALLERY_VIEW_MODE: 'Gallery view mode: streams will be presented side by side',
      CALL_BEING_RECORDED: 'This call is being recorded'
    },
    ACTIVE_AGENT: {
      IN: 'В',
      SECONDS: 'Секунди',
      PEOPLE_RECEIVED_CALLS_TODAY: 'Хората получиха обаждания днес',
      SECURED: 'Безопасен',
      FROM: 'От',
      IS_CALLING_YOU: 'ти се обажда',
      OVER_A_SECURED_WEBCALL: 'през защитено уеб повикване',
      ACCEPT: 'Приеми',
      DECLINE: 'Откажи',
      CALL_REQUEST: 'Имате заявка за обаждане',
      PAYMENT_REQUEST: 'Имате заявка за плащане',
      PAY_NOW: 'Плати сега',
      CANCEL: 'Затвори',
      END_FILE_KEEP_THIS_IN_THE_END: 'END_FILE_KEEP_THIS_IN_THE_END',
      '': ''
    }
  }
}
